import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import UploadForm from "components/shared-components/UploadForm";
import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  AUTH_STATUS_NEW,
  AUTH_STATUS_RR,
  SOURCE_QUEUE,
} from "constants/FormatDataContanst";
import {
  FIELD_DISABLE_CONFIG,
  ISSUE_INVOICE_BUYER_FIELD,
  ISSUE_INVOICE_COMMON_FIELD,
  ISSUE_INVOICE_HHDV_FIELD,
  ISSUE_INVOICE_PAYMENT_FIELD,
  ISSUE_INVOICE_SELLER_FIELD,
  MODE_INVOICE_ACTION,
  TYPE_ADJUST_INVOICE,
  TYPE_INVOICE_ANOTHER,
} from "constants/IssueInvoiceConstant";
import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import "flatpickr/dist/themes/material_blue.css";
import {
  EXTRA_BUTTON,
  formConvertErrorMessage,
  generateDateField,
  generateInputFieldArray,
  generateSelectFieldArray,
  loopGenerateField,
} from "helpers/form_helper_new";
import moment from "moment";
import { formatTimestampToDate } from "pages/DataFormatInvoice/utils";
import { FIELD_CUSTOMER } from "pages/GeneralInfo/Customer/utils";
import DetailData from "pages/GeneralInfo/Product/DetailData";
import { modeDetail } from "pages/GeneralInfo/Product/utils";
import PropTypes from "prop-types";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Table,
} from "reactstrap";
import {
  adjustIssueInvoice,
  createIssueInvoice,
  createIssueInvoiceEnterpriseAdjustAll,
  createListProductInvoice,
  downloadXmlIssueInvoice,
  editIssueInvoice,
  getAllProductInvoice,
  getDetailIssueInvoice,
  getEnterpriseByTaxCode,
  getInvoiceMaxDate,
  getInvoiceMinDate,
  getListVat,
  loadConfigInvoiceField,
  replaceIssueInvoice,
  resetCreateIssueInvoice,
  resetCreateIssueInvoiceEnterpriseAdjustAll,
  resetCreateProductInvoice,
  resetEditIssueInvoice,
  resetGetDetailIssueInvoice,
  resetGetEnterpriseByTaxCode,
  resetGetInvoiceMaxDate,
  resetGetInvoiceMinDate,
  resetUploadAttackFileInvoice,
  uploadAttackFileInvoice,
} from "store/actions";
import {
  getAllAccountBank,
  getAllCustomerInvoice,
  resetCreateAccountBank,
} from "store/general-info/customer/actions";
import {
  CREATE_ACCOUNT_BANK_FAIL,
  CREATE_ACCOUNT_BANK_SUCCESS,
} from "store/general-info/customer/actionTypes";
import {
  CREATE_PRODUCT_INVOICE_FAIL,
  CREATE_PRODUCT_INVOICE_SUCCESS,
} from "store/general-info/product/actionTypes";
import {
  CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_FAIL,
  CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_SUCCESS,
  GET_INVOICE_MIN_DATE_FAIL,
  GET_INVOICE_MIN_DATE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import writeXlsxFile from "write-excel-file";
import * as yup from "yup";
import "./detailInvoice.scss";
import { operatorsHelper } from "./helper/functionHelper";
import CreateAccountBankModal from "./modal/CreateAccountBankModal";
import SearchCustomerModal from "./modal/SearchCustomerModal";
import UploadProductExcelModal from "./modal/UploadProductExcelModal";
import {
  changeYearOfSerial,
  checkDateWhenRelease,
  checkVisibleByConditionRowData,
  COMMON_CONDITION_VISIBLE,
  convertDate,
  customViewField,
  financial,
  fixConvertNumberToText,
  formatTienFinal,
  getDateMidnight,
  getIconFile,
  initOptionDateLocale,
  issueInvoiceModeList,
  issueInvoicePageViewList,
} from "./utils";

const DetailInvoice = forwardRef((props, ref) => {
  const {
    isPage, // check là modal hay page mới
    isOpenModal,
    isEnterprise,
    dataDetail,
    btnShowFooter,
    dataConfirmAction,
    toggleModal,
    mode,
    pageView,
    typeInvoiceAnother,
    khhdonDefault,
    showPdfById,
    invoiceSymbolList,
    setDataInvoiceTemp,
    setDataConfirmAction,
    setPageViewByRow,
    setMode,
    isRoleStore,
    isRoleAccountant,
    setTitleBodyDenyRelease,
    toggleDenyReleaseModal,
    setTitleBodyCheckRelease,
    toggleCheckReleaseModal,
  } = props;

  useImperativeHandle(ref, () => ({
    releaseFromDetail() {
      handleSubmit(onAllowRelease, beforeAllowRelease)();
    },
  }));

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["issueInvoice"]);
  const { addToast } = useToasts();
  const [disableForm, setDisableForm] = useState(true);
  const [isEditableAdjustReplace, setIsEditableAdjustReplace] = useState(true);
  const history = useHistory();
  // Search modal
  const [modalSearch, setModalSearch] = useState(false);
  const toggleSearchModal = () => setModalSearch(!modalSearch);

  // AccountBank modal
  const [modalAccountBank, setModalAccountBank] = useState(false);
  const toggleAddAccountBankModal = () =>
    setModalAccountBank(!modalAccountBank);

  // Product upload excel modal
  const [modalImportProduct, setModalImportProduct] = useState(false);
  const toggleImportProductModal = () =>
    setModalImportProduct(!modalImportProduct);

  // Product modal
  const [modalProduct, setModalProduct] = useState(false);
  const toggleAddProductModal = () => setModalProduct(!modalProduct);

  const [isFirstLoad, setIsFirstLoad] = useState(false);

  const [isTypeAdjustIncDesc, setIsTypeAdjustIncDesc] = useState(false);
  const [isTypeAdjustChangeInfo, setIsTypeAdjustChangeInfo] = useState(false);
  const [isShowLimitAdjust, setIsShowLimitAdjust] = useState(false);

  const [isReleaseGlobal, setIsReleaseGlobal] = useState(false);

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingCreate,
    errorCreate,
    create: issueInvoiceCreate,

    loadingEdit,
    errorEdit,
    edit: issueInvoiceEdit,

    configField,

    uploadFile,
    loadingUploadFile,
    invoiceMaxDate,
    invoiceMaxMinDate,
    type: typeInvoice,
    createInvoiceEnterpriseAdjustAllData,
    currentTime,
  } = issueInvoice;

  const {
    loading: loadingDetail,
    data: detailIssueInvoice,
    error,
  } = issueInvoice.detailIssueInvoice;
  const {
    loading: loadDingEnterpriseByTaxCode,
    data: enterpriseByTaxCode,
    error: errorEnterprise,
  } = issueInvoice.enterpriseByTaxCode;

  const {
    loading: loadingConfigField,
    // businessUnitInfo,
    listCurrency,
    listVat,
    listPaymentMethod,
  } = configField;

  const listPageViewHaveTSUAT = [
    issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE,
    issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE,
    issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE,
    issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE,
  ];

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail

  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuReleaseInfo, buStoreHeader, finalBuInfo } = Dashboard;

  const [typeAnother, setTypeAnother] = useState(null);
  const modal = useRef(null);
  const modalTable = useRef(null);
  const setDefaultConfigField = () => {
    const defaultBusinessUnitInfoField = {
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_TEN.field]: "ten",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_MST.field]: "mst",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_DCHI.field]: "dchi",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_DCTDTU.field]: "dctdtu",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_FAX.field]: "fax",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_SDTHOAI.field]: "sdthoai",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_STKNHANG.field]: "stknhang",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_TNHANG.field]: "tnhang",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_WEBSITE.field]: "website",
      [ISSUE_INVOICE_BUYER_FIELD.SEND_MAIL.field]: "send_mail",
    };
    if (finalBuReleaseInfo) {
      for (const key in defaultBusinessUnitInfoField) {
        const defaultValue =
          finalBuReleaseInfo[defaultBusinessUnitInfoField[key]];
        if (key === ISSUE_INVOICE_SELLER_FIELD.NBAN_STKNHANG.field) {
          setValue(key, {
            value: defaultValue,
            label: defaultValue,
          });
        } else {
          if (key === "send_mail") {
            setInputCBSendMailChange(defaultValue ? true : false);
          }
          if (defaultValue) {
            setValue(key, defaultValue);
          } else {
            setValue(key, "");
          }
        }
      }
    }
    // Set config hình thức thanh toán
    setHTTTOAN(listPaymentMethod);
    setValue(COMMON_FIELD.TTCHUNG_HTTTOAN.field, null);

    // Set config đơn vị tiền tệ
    setDVTTE(listCurrency);
    setValue(COMMON_FIELD.TTCHUNG_DVTTE.field, listCurrency[0]);

    // Set config thuế suất
    setTSUAT(listVat);

    setOPTION_GROUP({
      ...OPTION_GROUP,
      [COMMON_FIELD.TTCHUNG_HTTTOAN.field]: listPaymentMethod,
      [COMMON_FIELD.TTCHUNG_DVTTE.field]: listCurrency,
      [HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]:
        productInvoice.listAllProduct.map(item => {
          return {
            ...item,
            value: item.code,
            label: item.code,
          };
        }),
      [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: productInvoice.listAllProduct,
      [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: listVat,
      [PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list.TSUAT.field]: listVat,
      [BUYER_FIELD.NMUA_STKNHANG.field]: customerInvoice?.listAllAccountBank,
      [BUYER_FIELD.NMUA_MKHANG.field]: customerInvoice?.listAllCustomer,
    });

    if (!configField.loadingConfigField) {
      setTimeout(() => {
        if (modal && modal.current) {
          modal.current.scrollTop = 0;
        }
      });
    }
  };

  const COMMON_FIELD = ISSUE_INVOICE_COMMON_FIELD;
  const COMMON_FIELD_ARRAY = [];
  for (const key in COMMON_FIELD) {
    COMMON_FIELD_ARRAY.push(key);
  }

  const SELLER_FIELD = ISSUE_INVOICE_SELLER_FIELD;
  const SELLER_FIELD_ARRAY = [];
  for (const key in SELLER_FIELD) {
    SELLER_FIELD_ARRAY.push(key);
  }

  const BUYER_FIELD = ISSUE_INVOICE_BUYER_FIELD;
  const BUYER_FIELD_ARRAY = [];
  for (const key in BUYER_FIELD) {
    BUYER_FIELD_ARRAY.push(key);
  }

  const HHDV_FIELD = ISSUE_INVOICE_HHDV_FIELD;
  const HHDV_FIELD_ARRAY = [];
  for (const key in HHDV_FIELD) {
    HHDV_FIELD_ARRAY.push(key);
  }
  const TCHAT_VALUES =
    ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.TCHAT.selectValues;

  const PAYMENT_FIELD = ISSUE_INVOICE_PAYMENT_FIELD;
  const PAYMENT_FIELD_ARRAY = [];
  for (const key in PAYMENT_FIELD) {
    PAYMENT_FIELD_ARRAY.push(key);
  }

  const OPTION_TTCHUNG_KHMSHDON = [
    {
      value: COMMON_FIELD.TTCHUNG_KHMSHDON.selectValues.SALE_INVOICE,
      label: COMMON_FIELD.TTCHUNG_KHMSHDON.selectValues.SALE_INVOICE + "",
    },
    {
      value: COMMON_FIELD.TTCHUNG_KHMSHDON.selectValues.VAT_INVOICE,
      label: COMMON_FIELD.TTCHUNG_KHMSHDON.selectValues.VAT_INVOICE + "",
    },
    {
      value: COMMON_FIELD.TTCHUNG_KHMSHDON.selectValues.TICKETS_INVOICE,
      label: COMMON_FIELD.TTCHUNG_KHMSHDON.selectValues.TICKETS_INVOICE + "",
    },
  ];
  const OPTION_TTCHUNG_HDDCKPTQUAN = [
    {
      value: "1",
      label: "1 - Hóa đơn dành cho tổ chức, cá nhân trong khu phi thuế quan",
    },
    {
      value: "0",
      label:
        "0 - Hóa đơn dành cho tổ chức, cá nhân không nằm trong khu phi thuế quan",
    },
  ];

  const OPTION_HHDV_TCHAT = [
    {
      value: TCHAT_VALUES.GOODS,
      label: "Hàng hóa, dịch vụ",
    },
    {
      value: TCHAT_VALUES.PROMOTION,
      label: "Khuyến mãi",
    },
    {
      value: TCHAT_VALUES.DISCOUNT,
      label: "Chiết khấu thương mại",
    },
    {
      value: TCHAT_VALUES.EXPLAIN,
      label: "Ghi chú/diễn giải",
    },
  ];

  const [OPTION_TTCHUNG_HTTTOAN, setHTTTOAN] = useState([]);
  const [OPTION_TTCHUNG_DVTTE, setDVTTE] = useState([]);
  const [OPTION_HHDV_TSUAT, setTSUAT] = useState([]);

  const [OPTION_GROUP, setOPTION_GROUP] = useState({
    // [COMMON_FIELD.TTCHUNG_KHMSHDON.field]: OPTION_TTCHUNG_KHMSHDON,
    [COMMON_FIELD.TTCHUNG_HDDCKPTQUAN.field]: OPTION_TTCHUNG_HDDCKPTQUAN,
    [COMMON_FIELD.TTCHUNG_DVTTE.field]: OPTION_TTCHUNG_DVTTE,
    [COMMON_FIELD.TTCHUNG_HTTTOAN.field]: OPTION_TTCHUNG_HTTTOAN,
    [HHDV_FIELD.HHDV_OBJ.list.TCHAT.field]: OPTION_HHDV_TCHAT,
    [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: OPTION_HHDV_TSUAT,
    [PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list.TSUAT.field]: OPTION_HHDV_TSUAT,
    [ISSUE_INVOICE_SELLER_FIELD.NBAN_STKNHANG.field]: [],
    [ISSUE_INVOICE_BUYER_FIELD.NMUA_STKNHANG.field]: [],
    [ISSUE_INVOICE_BUYER_FIELD.NMUA_MKHANG.field]: [],
  });

  const objSchema = {};
  const initDefaultValues = {};
  const TOTAL_FIELD = {
    ...COMMON_FIELD,
    ...SELLER_FIELD,
    ...BUYER_FIELD,
    ...HHDV_FIELD,
    ...PAYMENT_FIELD,
  };

  const TOTAL_FIELD_ARRAY = [
    ...COMMON_FIELD_ARRAY,
    ...SELLER_FIELD_ARRAY,
    ...BUYER_FIELD_ARRAY,
    ...HHDV_FIELD_ARRAY,
    ...PAYMENT_FIELD_ARRAY,
  ];

  TOTAL_FIELD_ARRAY.map(item => {
    const itemField = TOTAL_FIELD[item];
    switch (itemField.type) {
      case "text":
        initDefaultValues[itemField.field] = "";

        objSchema[itemField.field] = yup.string();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.required", { title: t(`form.${itemField.field}`) })
          );
        }
        if (itemField.max) {
          objSchema[itemField.field] = objSchema[itemField.field].max(
            itemField.max,
            t("form.validate.char_max", { max: itemField.max })
          );
        }
        if (itemField.isEmail) {
          objSchema[itemField.field] = objSchema[itemField.field].email(
            t("form.validate.invalid", { title: t(`form.${itemField.field}`) })
          );
        }
        if (itemField.isTaxCode) {
          objSchema[itemField.field] = objSchema[itemField.field].test(
            "len",
            "Vui lòng nhập 10 hoặc 14 ký tự",
            val => val.length === 0 || val.length === 10 || val.length === 14
          );
        }
        if (itemField.isKHHD) {
          //   objSchema[itemField.field] = objSchema[itemField.field].matches(
          //     /^[A]*$/,
          //     "Vui lòng chỉ nhập các ký tự (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)"
          //   );
          // objSchema[itemField.field] = objSchema[itemField.field].test(
          //   "len",
          //   "Vui lòng nhập 2 ký tự cuối (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)",
          //   val => {
          //     return val.length === 6;
          //   }
          // );
          initDefaultValues[itemField.field] = undefined;

          objSchema[itemField.field] = objSchema[itemField.field];
          objSchema[itemField.field] = yup.object();
          if (itemField.required) {
            objSchema[itemField.field] = objSchema[itemField.field].required(
              t("form.validate.select", { title: t(`form.${itemField.field}`) })
            );
          }
        }
        // Nếu có nhập MST người mua thì phải nhập địa chỉ
        if (itemField.field === ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field) {
          objSchema[itemField.field] = objSchema[itemField.field].when(
            ISSUE_INVOICE_BUYER_FIELD.NMUA_MST.field,
            {
              is: name => name.length === 10 || name.length === 14,
              then: yup.string().required(
                t("form.validate.required", {
                  title: t(`form.${ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field}`),
                })
              ),
            }
          );
        }
        // Nếu có nhập MST người mua thì phải nhập email
        if (itemField.field === ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field) {
          objSchema[itemField.field] = objSchema[itemField.field].when(
            ISSUE_INVOICE_BUYER_FIELD.NMUA_MST.field,
            {
              is: name => name.length === 10 || name.length === 14,
              then: yup.string().required(
                t("form.validate.required", {
                  title: t(
                    `form.${ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field}`
                  ),
                })
              ),
            }
          );
        }
        break;
      case "number":
        initDefaultValues[itemField.field] = "";

        objSchema[itemField.field] = yup.string();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.required", { title: t(`form.${itemField.field}`) })
          );
        }

        // objSchema[itemField.field] = objSchema[itemField.field].matches(
        //   /^[0-9]+$/,
        //   t("form.validate.integer")
        // );

        if (itemField.max) {
          objSchema[itemField.field] = objSchema[itemField.field].max(
            itemField.max,
            t("form.validate.integer_max", { max: itemField.max })
          );
        }
        // Bắt buộc có tỷ giá (trừ đơn vị tiền tệ là VNĐ
        if (itemField.field === ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_TGIA.field) {
          objSchema[itemField.field] = objSchema[itemField.field].when(
            ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_DVTTE.field,
            {
              is: value => {
                return value.value !== "VND";
              },
              then: yup.string().required(
                t("form.validate.required", {
                  title: t(
                    `form.${ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_TGIA.field}`
                  ),
                })
              ),
            }
          );
        }
        break;
      case "select":
        if (itemField.field === COMMON_FIELD.TTCHUNG_HDDCKPTQUAN.field) {
          initDefaultValues[itemField.field] = OPTION_TTCHUNG_HDDCKPTQUAN[1];
        } else {
          initDefaultValues[itemField.field] = undefined;
        }
        objSchema[itemField.field] = yup.object().nullable();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.select", { title: t(`form.${itemField.field}`) })
          );
        }
        break;
      case "date":
        initDefaultValues[itemField.field] = [];

        objSchema[itemField.field] = yup.array();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].min(
            1,
            t("form.validate.select", { title: t(`form.${itemField.field}`) })
          );
        }
        break;
      case "field_array":
        objSchema[itemField.field] = yup
          .array()
          .min(1, t("form.validate.least_one_line"));
        const objSchemaFieldArray = {};

        const listField = itemField.list;
        const arrayField = [];
        for (const key in listField) {
          if (key !== "STT") {
            arrayField.push(key);
          }
        }

        arrayField.map(x => {
          const itemFieldArray = listField[x];
          switch (itemFieldArray.type) {
            case "text":
              objSchemaFieldArray[itemFieldArray.field] = yup
                .string()
                .nullable();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].required(
                  t("form.validate.required", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }
              if (itemFieldArray.max) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].max(
                  itemFieldArray.max,
                  t("form.validate.char_max", { max: itemFieldArray.max })
                );
              }
              break;
            case "number":
              objSchemaFieldArray[itemFieldArray.field] = yup
                .string()
                .nullable();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].required(
                  t("form.validate.required", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }

              //   objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
              //     itemFieldArray.field
              //   ].matches(/^[0-9]+$/, t("form.validate.integer"));

              if (itemFieldArray.max) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].max(
                  itemFieldArray.max,
                  t("form.validate.integer_max", { max: itemFieldArray.max })
                );
              }
              break;
            case "select":
              objSchemaFieldArray[itemFieldArray.field] = yup
                .object()
                .nullable();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].required(
                  t("form.validate.select", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }
              break;
            case "date":
              objSchemaFieldArray[itemFieldArray.field] = yup.array();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].min(
                  1,
                  t("form.validate.select", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }
              break;
            default:
              break;
          }
        });

        objSchema[itemField.field] = objSchema[itemField.field].of(
          yup.object().shape(objSchemaFieldArray)
        );
        break;
      case "object":
        objSchema[itemField.field] = yup.mixed().nullable();
        break;
      default:
        break;
    }
  });

  // ---Set Other Default Value---
  initDefaultValues[COMMON_FIELD.PBAN.field] = "2.0.0";
  initDefaultValues[COMMON_FIELD.TTCHUNG_SHDON.field] = "Chờ cấp số";

  initDefaultValues[COMMON_FIELD.TTCHUNG_NLAP.field] = [
    getDateMidnight(currentTime?.data?.date),
  ];
  initDefaultValues[COMMON_FIELD.TTCHUNG_TGIA.field] = 1;
  initDefaultValues[COMMON_FIELD.TTCHUNG_MSTTCGP.field] = "0302999571";
  initDefaultValues[COMMON_FIELD.TTCHUNG_DCDVNUNLHDON.field] = ""; // TODO not require in BE

  initDefaultValues[ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TGTCTHUE.field] = 0;
  initDefaultValues[ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TGTTHUE.field] = 0;
  initDefaultValues[ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TTCKTMAI.field] = 0;
  initDefaultValues[ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TGTTTBSO.field] = 0;

  //CUSTOM_VIEW
  const FIRST_BLOCK = [
    ISSUE_INVOICE_SELLER_FIELD.NBAN_TEN,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_THDON,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_KHHDON,
    ISSUE_INVOICE_SELLER_FIELD.NBAN_MST,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_SHDON,
    ISSUE_INVOICE_SELLER_FIELD.NBAN_DCHI,
    // ISSUE_INVOICE_SELLER_FIELD.NBAN_SDTHOAI,
    // ...ISSUE_INVOICE_COMMON_FIELD,
  ];

  const SECOND_BLOCK = [
    ISSUE_INVOICE_BUYER_FIELD.NMUA_MST,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_HVTNMHANG,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_MKHANG,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_TEN,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_SDTHOAI,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU,
    ISSUE_INVOICE_BUYER_FIELD.SEND_MAIL,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_HTTTOAN,
    ISSUE_INVOICE_SELLER_FIELD.NBAN_STKNHANG,
    ISSUE_INVOICE_SELLER_FIELD.NBAN_TNHANG,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_DVTTE,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_STKNHANG,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_TNHANG,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_TGIA,
    ISSUE_INVOICE_COMMON_FIELD.NOTE,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_HDDCKPTQUAN,
  ];
  //

  const schema = yup.object().shape(objSchema);
  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...initDefaultValues,
    },
  });
  const customerInvoice = useSelector(state => state.customerInvoice);
  const { listAllCustomer, loadListAllCustomer } = customerInvoice;

  const [isShowBtnAddCustomer, setIsShowBtnAddCustomer] = useState(false);

  useEffect(() => {
    if (isOpenModal && enterpriseByTaxCode?.taxCode) {
      if (
        listAllCustomer.findIndex(
          item => item.mst === enterpriseByTaxCode?.taxCode
        ) === -1
      ) {
        setIsShowBtnAddCustomer(true);
      } else {
        setIsShowBtnAddCustomer(false);
      }
    }
  }, [enterpriseByTaxCode]);

  // Action Dispatch
  useEffect(() => {
    console.log("error", errors);
  }, [errors]);

  const [listUploadFile, setListUploadFile] = useState([]);
  const [listHaveUploadFile, setListHaveUploadFile] = useState([]);
  // Action Dispatch
  useEffect(() => {
    if (uploadFile && uploadFile.success) {
      setListUploadFile([
        ...listUploadFile,
        { id: uploadFile.id, file_name: "" },
      ]);
      dispatch(resetUploadAttackFileInvoice());
    }
    // console.log("error", errors);
  }, [uploadFile]);

  const productInvoice = useSelector(state => state.productInvoice);

  useEffect(() => {
    if (productInvoice) {
      //   console.log(
      //     "🚀 ~ file: DetailInvoice.js ~ line 673 ~ useEffect ~ productInvoice",
      //     productInvoice
      //   );
      setOPTION_GROUP({
        ...OPTION_GROUP,
        [HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]:
          productInvoice.listAllProduct.map(item => {
            return {
              ...item,
              value: item.code,
              label: item.code,
            };
          }),
        [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: productInvoice.listAllProduct,
      });
    }
    // console.log("error", errors);
  }, [productInvoice.listAllProduct]);

  useEffect(() => {
    if (customerInvoice) {
      setOPTION_GROUP({
        ...OPTION_GROUP,
        [BUYER_FIELD.NMUA_STKNHANG.field]: customerInvoice.listAllAccountBank,
        [BUYER_FIELD.NMUA_MKHANG.field]: customerInvoice.listAllCustomer,
      });
    }
    // console.log("error", errors);
  }, [customerInvoice.listAllAccountBank]);

  useEffect(() => {
    switch (productInvoice.type) {
      case CREATE_PRODUCT_INVOICE_SUCCESS:
        addToast("Thêm sản phẩm mới thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleAddProductModal();
        dispatch(getAllProductInvoice());
        dispatch(resetCreateProductInvoice());
        break;
      case CREATE_PRODUCT_INVOICE_FAIL:
        if (
          productInvoice.createProduct.error.code === 422 &&
          productInvoice.createProduct.error.fields.length > 0
        ) {
          productInvoice.createProduct.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.create", {
                      target: t("product"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`Mã` + " không hợp lệ.")
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetCreateProductInvoice());
        break;
      default:
        break;
    }
  }, [productInvoice.type]);

  useEffect(() => {
    switch (customerInvoice.type) {
      case CREATE_ACCOUNT_BANK_SUCCESS:
        addToast("Thêm tài khoản thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleAddAccountBankModal();
        dispatch(getAllAccountBank());
        dispatch(resetCreateAccountBank());
        break;
      case CREATE_ACCOUNT_BANK_FAIL:
        if (
          customerInvoice.createAccountBankData.error.code === 422 &&
          customerInvoice.createAccountBankData.error.fields.length > 0
        ) {
          customerInvoice.createAccountBankData.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.create", {
                      target: t("product"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`Mã` + " không hợp lệ.")
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetCreateAccountBank());
        break;
      default:
        break;
    }
  }, [customerInvoice.type]);

  useEffect(() => {
    switch (typeInvoice) {
      case CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_SUCCESS:
        addToast("Tạo hóa đơn điều chỉnh giảm 100% thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetCreateIssueInvoiceEnterpriseAdjustAll());
        // if (createInvoiceEnterpriseAdjustAllData?.data?.id) {
        //   history.push(
        //     `/invoice/${createInvoiceEnterpriseAdjustAllData?.data?.id}`
        //   );
        // }
        break;
      case CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_FAIL:
        addToast("Tạo hóa đơn điều chỉnh giảm 100% thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCreateIssueInvoiceEnterpriseAdjustAll());
        break;
      case GET_INVOICE_MIN_DATE_SUCCESS:
        if (isOpenModal) {
          const currentNlap = getValues(
            ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP.field
          );
          checkDateWhenRelease(
            invoiceMaxMinDate.data.min,
            invoiceMaxMinDate.data.max,
            new Date(currentNlap),
            (nlapLabel, minDateLabel, maxDateLabel) => {
              //   setTitleBodyDenyRelease(
              //     `Đã có hóa đơn phát hành ngày ${maxDateLabel}. Vui lòng  cập nhật ngày lập của HĐ hiện tại về ${maxDateLabel} hoặc lớn hơn (nhưng phải nhỏ hơn ngày hiên tại).`
              //   );
              //   toggleDenyReleaseModal();
              handleSubmit(onAllowRelease, beforeAllowRelease)();
            },
            (nlapLabel, minDateLabel, maxDateLabel) => {
              //   setTitleBodyCheckRelease(
              //     `Đang có Hóa Đơn lưu tạm có ngày lập (${minDateLabel}) nhỏ hơn ngày lập của hóa đơn hiện tại (${nlapLabel}), bạn có muốn tiếp tục phát hành hóa đơn này hay không?`
              //   );
              //   toggleCheckReleaseModal();
              handleSubmit(onAllowRelease, beforeAllowRelease)();
            },
            () => {
              handleSubmit(onAllowRelease, beforeAllowRelease)();
            }
          );
          dispatch(resetGetInvoiceMinDate());
        }
        break;
      case GET_INVOICE_MIN_DATE_FAIL:
        if (isOpenModal) {
          addToast("Lấy thông tin ngày lập hóa đơn lưu tạm xa nhất thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(resetGetInvoiceMinDate());
        }
        break;
      default:
        break;
    }
  }, [typeInvoice]);

  // Action Dispatch
  useEffect(() => {
    dispatch(getAllProductInvoice());
    dispatch(getListVat());
  }, []);

  // Action Dispatch
  useEffect(() => {
    if (buStoreHeader) {
      dispatch(getAllAccountBank());
    }
  }, [buStoreHeader]);

  // setDefaultConfigField
  useEffect(() => {
    if (configField.isFinish) {
      setDefaultConfigField();
      setValue(COMMON_FIELD.TTCHUNG_NLAP.field, [currentTime?.data?.date]);
      //
      if (dataConfirmAction?.typeAdjust !== TYPE_ADJUST_INVOICE.CHANGE_INFO) {
        addNewLineHHDV();
        addNewLineHHDV();
        addNewLineHHDV();
        addNewLineHHDV();
        addNewLineHHDV();
        addNewLineTTOAN_LTSUAT();
      }
      if (dataDetail.id) {
        let isAdjustDecrease =
          dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE;
        dispatch(
          getDetailIssueInvoice(
            dataDetail.id,
            typeAnother,
            null,
            isAdjustDecrease
          )
        );
      } else if (
        // Điều chỉnh thông tin hóa đơn 32
        dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.CHANGE_INFO
      ) {
        defaultDataAdjustChangeInfo();
      }
      if (!dataDetail.id) {
        const khhdon = getValues(
          ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_KHHDON.field
        );
        const khmshdon = getValues(
          ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_KHMSHDON.field
        );
        dispatch(getInvoiceMaxDate(khmshdon, khhdon));
      }
    }
  }, [configField]);

  useEffect(() => {
    // Check ngày lập hiện tại với ngày hóa đơn phát hành mới nhất
    if (
      isOpenModal &&
      invoiceMaxDate.data &&
      detailIssueInvoice &&
      !disableForm
    ) {
      const nlapData = getValues(
        ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP.field
      )[0];

      const nlap = moment(new Date(nlapData)).format("YYYY-MM-DD");
      console.log(
        "🚀 ~ file: DetailInvoice.js ~ line 930 ~ useEffect ~ nlap",
        nlap
      );
      const maxDate = moment(invoiceMaxDate.data, ",'DD-MM-YYYY'").format(
        "YYYY-MM-DD"
      );
      console.log(
        "🚀 ~ file: DetailInvoice.js ~ line 1054 ~ useEffect ~ maxDate",
        maxDate
      );
      const checkRemove = nlap < maxDate;
      console.log(
        "🚀 ~ file: DetailInvoice.js ~ line 1059 ~ useEffect ~ checkRemove",
        checkRemove
      );
      if (checkRemove) {
        setValue(ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP.field, [], {
          shouldValidate: true,
        });
      } else {
        setValue(
          ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP.field,
          [getDateMidnight(nlapData)],
          {
            shouldValidate: true,
          }
        );
      }
    }
  }, [invoiceMaxDate]);

  const setFileHaveUpload = () => {
    const listUploadFile = [];
    if (detailIssueInvoice?.resource_list) {
      for (const item of detailIssueInvoice.resource_list) {
        if (item.type === "attach") {
          const splitType = item?.file_name.split(".");
          const fileType = splitType[splitType.length - 1];
          listUploadFile.push({
            id: item.id,
            file_name: item.file_name.split("-")[0],
            file_type: fileType,
          });
        }
      }
      setListHaveUploadFile(listUploadFile);
    }
  };

  // Khi là trang riêng
  const handleWhenLoadFromPage = () => {
    if (isPage && detailIssueInvoice) {
      if (detailIssueInvoice.tthdlquan_tchdon) {
        let mode = null;
        if (detailIssueInvoice.tthdlquan_lhdclquan === "3") {
          mode = MODE_INVOICE_ACTION.REPLACE;
        } else {
          switch (detailIssueInvoice.tthdlquan_tchdon) {
            case "1":
              mode = MODE_INVOICE_ACTION.REPLACE;
              break;
            case "2":
              mode = MODE_INVOICE_ACTION.ADJUST;
              break;
            default:
              break;
          }
        }
        setDataConfirmAction({
          modeEdit: mode,
          typeAdjust: detailIssueInvoice.adjust_mod,
        });
      } else {
        setDataConfirmAction(null);
      }
      setPageViewByRow(detailIssueInvoice);
      const canEdit =
        checkVisibleByConditionRowData(
          COMMON_CONDITION_VISIBLE.EDIT,
          detailIssueInvoice
        ) ||
        checkVisibleByConditionRowData(
          COMMON_CONDITION_VISIBLE.EDIT_QUEUE_MSEAG,
          detailIssueInvoice
        );
      setDisableForm(canEdit ? false : true);
      switch (detailIssueInvoice.ttchung_khmshdon) {
        case "1":
          setMode(
            canEdit
              ? issueInvoiceModeList.EDIT_VAT_INVOICE_DETAIL
              : issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL
          );
          break;
        case "2":
          setMode(
            canEdit
              ? issueInvoiceModeList.EDIT_SALE_INVOICE_DETAIL
              : issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL
          );
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    if (detailIssueInvoice && isOpenModal) {
      setIsFirstLoad(true);
      dispatch(
        getInvoiceMaxDate(
          detailIssueInvoice?.ttchung_khmshdon,
          changeYearOfSerial(
            detailIssueInvoice?.ttchung_khhdon,
            currentTime?.data?.year.toString()
          ),
          detailIssueInvoice?.bu_code
        )
      );
      handleWhenLoadFromPage();
      // Check show Hạn mức điều chỉnh
      if (
        dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE &&
        (dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST || // Tạo mới hóa đơn điều chỉnh
          (dataConfirmAction?.modeEdit === MODE_INVOICE_ACTION.ADJUST && // HÓa đơn điều chỉnh lưu tạm
            detailIssueInvoice?.auth_status === AUTH_STATUS_NEW))
      ) {
        setIsShowLimitAdjust(true);
      }
      //Disalbe custom field nếu có
      if (
        detailIssueInvoice.is_editable === 0 ||
        detailIssueInvoice.is_editable === false
        //   &&
        // // Điều chỉnh giảm và thay thế mode tạo mới lần đầu
        // (dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
        //   (dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST &&
        //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE) ||
        //   // Điều chỉnh giảm và thay thế mode lần sau
        //   dataConfirmAction?.modeEdit === MODE_INVOICE_ACTION.REPLACE ||
        //   (dataConfirmAction?.modeEdit === MODE_INVOICE_ACTION.ADJUST &&
        //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE))
      ) {
        setIsEditableAdjustReplace(false);
      }
      // Nếu là hóa đơn điều chỉnh giảm lần đầu thì gợi ý âm số lượng
      let isCreateAdjustDecreaseInvoice =
        dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE &&
        !dataConfirmAction.modeEdit &&
        mode !== issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL &&
        mode !== issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL &&
        mode !== issueInvoiceModeList.VIEW_INVOICE_TICKETS_DETAIL;
      setFileHaveUpload();
      setDefaultValue(COMMON_FIELD);
      setDefaultValue(ISSUE_INVOICE_SELLER_FIELD);
      setDefaultValue(ISSUE_INVOICE_BUYER_FIELD);
      setDefaultValuePayment(
        ISSUE_INVOICE_PAYMENT_FIELD,
        isCreateAdjustDecreaseInvoice
      );
      setValue("send_mail", detailIssueInvoice.send_mail);
      const ttoan_ltsuatList = detailIssueInvoice.ttoan_ltsuat;
      if (ttoan_ltsuatList && ttoan_ltsuatList.length > 0) {
        setValue(
          ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field,
          ttoan_ltsuatList.map(item => {
            let ttoanTsuat = listVat.find(
              option => option.label === item.TSuat
            );
            // Trường hợp tsuat là input value
            if (item.TSuat && !ttoanTsuat) {
              ttoanTsuat = {
                value: item.TSuat.replace("%", ""),
                label: item.TSuat,
              };
            }
            // Điều chỉnh giảm
            let ttoan_thtien = item.ThTien;
            let ttoan_tthue = item.TThue;
            if (isCreateAdjustDecreaseInvoice) {
              ttoan_thtien = ttoan_thtien > 0 ? -ttoan_thtien : ttoan_thtien;
              ttoan_tthue = ttoan_tthue > 0 ? -ttoan_tthue : ttoan_tthue;
            }
            // Điều chỉnh thông tin
            if (dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.CHANGE_INFO) {
              ttoan_thtien = 0;
              ttoan_tthue = 0;
            }
            return {
              ttoan_tsuat: ttoanTsuat,
              ttoan_thtien: ttoan_thtien,
              ttoan_tthue: ttoan_tthue,
            };
          })
        );
      }
      const invoiceDetails = detailIssueInvoice.invoiceDetails;
      // Nếu điều chỉnh thông tin lần đầu
      if (
        dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.CHANGE_INFO &&
        !dataConfirmAction.modeEdit &&
        mode !== issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL &&
        mode !== issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL &&
        mode !== issueInvoiceModeList.VIEW_INVOICE_TICKETS_DETAIL
      ) {
        defaultDataAdjustChangeInfo();
      } else if (invoiceDetails && invoiceDetails.length > 0) {
        // set detail value cho THÔNG TIN DANH SÁCH HDDV
        // tchat mhhdvu thhdvu dvtinh sluong dgia tlckhau stckhau tsuat thtien ttkhac
        setValue(
          ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.field,
          invoiceDetails.map(item => {
            //Thuế suất
            let tsuatDetail = null;
            if (item.tsuat) {
              tsuatDetail = listVat.find(option => option.label === item.tsuat);
              // Trường hợp tsuat là input value
              if (!tsuatDetail) {
                tsuatDetail = {
                  value: Number(item.tsuat.replace(/KHAC:|.00%/g, "")),
                  label: item.tsuat,
                };
              }
            } else {
              tsuatDetail = {
                value: "",
                label: "",
              };
            }
            //Mã hàng hóa, dịch vụ, diễn giải
            // let mhhdvuDetail = null;
            // if (item.mhhdvu) {
            //   mhhdvuDetail = {
            //     value: item.mhhdvu,
            //     label: item.mhhdvu,
            //   };
            // }
            // //Tên hàng hóa, dịch vụ, diễn giải
            // let thhdvuDetail = {
            //   value: item.thhdvu,
            //   label: item.thhdvu,
            // };
            //

            let sluong = item.sluong;
            let thtien = item.thtien;
            let dgia = item.dgia;
            let stckhau = item.stckhau;
            // Điều chỉnh giảm
            if (isCreateAdjustDecreaseInvoice) {
              //   sluong = 0;
              sluong = sluong > 0 ? -sluong : sluong;
              thtien = thtien > 0 ? -thtien : thtien;
              stckhau = stckhau > 0 ? -stckhau : stckhau;
            }
            return {
              tchat: OPTION_HHDV_TCHAT.find(
                option => Number(option.value) === Number(item.tchat)
              ),
              mhhdvu: item.mhhdvu,
              thhdvu: item.thhdvu,
              dvtinh: item.dvtinh,
              sluong: sluong,
              dgia: dgia,
              tlckhau: item.tlckhau,
              stckhau: stckhau,
              tsuat: tsuatDetail,
              thtien: thtien,
              ttkhac: item.ttkhac,
            };
          })
        );
      }
      //   // Nếu là hóa đơn điều chỉnh giảm lần đầu thì gợi ý âm số lượng và tính lại tổng tiền các thứ
      //   if (isCreateAdjustDecreaseInvoice) {
      //     setTimeout(() => {
      //       autoSumGroupAll();
      //     });
      //   }
    }
  }, [detailIssueInvoice]);

  // Custom set default value
  const setDefaultValue = FIELDS => {
    for (const key in FIELDS) {
      const finalKey = FIELDS[key].field;
      const type = FIELDS[key].type;
      const finalValue = detailIssueInvoice[finalKey];
      if (finalValue) {
        switch (type) {
          case "object":
            setValue(finalKey, finalValue, { shouldValidate: true });
            break;
          case "select":
            const option = OPTION_GROUP[finalKey];
            const valueSelect = option.find(item => item.value === finalValue);
            if (valueSelect) {
              setValue(finalKey, valueSelect);
            } else if (finalValue) {
              setValue(finalKey, {
                value: finalValue,
                label: finalValue,
              });
            }
            break;
          case "number":
          case "text":
            // Mode thay thế hóa đơn và điều chỉnh
            if (
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST
            ) {
              switch (finalKey) {
                case COMMON_FIELD.TTCHUNG_SHDON.field:
                  setValue(finalKey, "Chờ cấp số");
                  break;
                case COMMON_FIELD.TTCHUNG_KHHDON.field:
                  // Set ký hiệu theo năm trên hệ thống
                  if (dataConfirmAction?.finalSerial) {
                    setTimeout(() => {
                      setValue(finalKey, dataConfirmAction?.finalSerial);
                    });
                  }
                  break;

                // case COMMON_FIELD.TTCHUNG_KHHDON.field:
                //   const subValue = String(finalValue).substring(
                //     String(finalValue).length - 2
                //   );

                //   const resultFind = invoiceSymbolList.find(
                //     item => item.khhdon === subValue
                //   );
                //   if (resultFind) {
                //     setValue(finalKey, {
                //       value: resultFind.id,
                //       label: resultFind.khhdon,
                //     });
                //   } else {
                //     setValue(finalKey, undefined);
                //   }
                //   break;
                default:
                  setValue(finalKey, finalValue);
                  break;
              }
            } else {
              switch (finalKey) {
                case COMMON_FIELD.TTCHUNG_KHHDON.field:
                  // Nếu sang năm thì phải tăng năm
                  const serial = changeYearOfSerial(
                    finalValue,
                    currentTime?.data?.year.toString()
                  );
                  setTimeout(() => {
                    setValue(finalKey, serial);
                  });
                  break;
                default:
                  setValue(finalKey, finalValue);
                  break;
              }
            }
            break;
          case "date":
            if (
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST
            ) {
              switch (finalKey) {
                case COMMON_FIELD.TTCHUNG_NLAP.field:
                  setValue(finalKey, [
                    getDateMidnight(currentTime?.data?.date),
                  ]);
                  break;
                default:
                  const date = formatTimestampToDate(finalValue);
                  setValue(finalKey, [date]);
                  break;
              }
            } else {
              const date = formatTimestampToDate(finalValue);
              setValue(finalKey, [date]);
            }
            break;
        }
      }
    }
  };

  const setDefaultValuePayment = (FIELDS, isCreateAdjustDecreaseInvoice) => {
    for (const key in FIELDS) {
      const finalKey = FIELDS[key].field;
      const type = FIELDS[key].type;
      const finalValue = detailIssueInvoice[finalKey];
      if (finalValue) {
        switch (type) {
          case "number":
            let data = finalValue;
            if (isCreateAdjustDecreaseInvoice) {
              data = data > 0 ? -data : data;
            }
            setValue(finalKey, data);
            break;
          case "text":
            //ttoan_tgtttbchu
            let ttoan_tgtttbchu = finalValue;
            ttoan_tgtttbchu =
              ttoan_tgtttbchu.charAt(0).toUpperCase() +
              ttoan_tgtttbchu.slice(1);
            let textChange = "";
            switch (dataConfirmAction?.typeAdjust) {
              case TYPE_ADJUST_INVOICE.INCREASE:
                textChange = "Điều chỉnh tăng ";
                break;
              case TYPE_ADJUST_INVOICE.DECREASE:
                textChange = "Điều chỉnh giảm ";
                break;
              default:
                break;
            }
            setValue(finalKey, textChange + ttoan_tgtttbchu);
            break;
        }
      }
    }
  };

  const {
    fields: fieldsHHDV,
    append: appendHHDV,
    remove: removeHHDV,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: HHDV_FIELD.HHDV_OBJ.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const {
    fields: fieldsTTOAN_LTSUAT,
    append: appendTTOAN_LTSUAT,
    remove: removeTTOAN_LTSUAT,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  //   const {
  //     fields: fieldsTTOAN_LPHI,
  //     append: appendTTOAN_LPHI,
  //     remove: removeTTOAN_LPHI,
  //   } = useFieldArray({
  //     control, // control props comes from useForm (optional: if you are using FormContext)
  //     name: PAYMENT_FIELD.TTOAN_LPHI_OBJ.field, // unique name for your Field Array
  //     keyName: "key", // keyName: "id", default to "id", you can change the key name
  //   });

  const setTypeInvoice = () => {
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE:
        setTypeAnother(TYPE_INVOICE_ANOTHER.INVOICE_TICKETS);
        break;
      default:
        break;
    }
  };

  const resetTable = () => {
    setCurrentPage(0);
    setItemOffset(0);
    setItemsPerPage(listSizePerPage[0]);
    setPageCount(0);
  };

  useEffect(() => {
    if (!isOpenModal) {
      setIsReleaseGlobal(false);
      dispatch(resetGetInvoiceMaxDate());
      setIsShowLimitAdjust(false);
      setIsEditableAdjustReplace(true);
      dispatch(resetGetDetailIssueInvoice());
      setIsDetail(false);
      reset({ ...initDefaultValues });
      dispatch(resetGetEnterpriseByTaxCode());
      resetTable();
      setIsShowBtnAddCustomer(false);
      // setControlFields(initControlFields);
    } else {
      dispatch(getAllCustomerInvoice());
      setListUploadFile([]);
      checkDisableForm();
      setTypeInvoice();
      dispatch(loadConfigInvoiceField());
      //   addNewLineTTOAN_LPHI();
      switch (mode) {
        case issueInvoiceModeList.CREATE_VAT_INVOICE_DETAIL:
          setValue(
            COMMON_FIELD.TTCHUNG_THDON.field,
            "HÓA ĐƠN ĐIỆN TỬ GIÁ TRỊ GIA TĂNG"
          );
          setValue(
            COMMON_FIELD.TTCHUNG_KHMSHDON.field,
            OPTION_TTCHUNG_KHMSHDON[1].value,
            { shouldValidate: true }
          );
          setValue(COMMON_FIELD.TTCHUNG_KHHDON.field, khhdonDefault, {
            shouldValidate: true,
          });
          break;
        case issueInvoiceModeList.CREATE_SALE_INVOICE_DETAIL:
          setValue(
            COMMON_FIELD.TTCHUNG_THDON.field,
            "HÓA ĐƠN ĐIỆN TỬ BÁN HÀNG"
          );
          setValue(
            COMMON_FIELD.TTCHUNG_KHMSHDON.field,
            OPTION_TTCHUNG_KHMSHDON[0].value,
            { shouldValidate: true }
          );
          setValue(COMMON_FIELD.TTCHUNG_KHHDON.field, khhdonDefault, {
            shouldValidate: true,
          });
          break;
        case issueInvoiceModeList.CREATE_INVOICE_TICKETS_DETAIL:
          setValue(
            COMMON_FIELD.TTCHUNG_THDON.field,
            "TEM VÉ THUỘC LOAI HÓA ĐƠN GIÁ TRỊ GIA TĂNG"
          );
          setValue(
            COMMON_FIELD.TTCHUNG_KHMSHDON.field,
            OPTION_TTCHUNG_KHMSHDON[2].value,
            { shouldValidate: true }
          );
          break;
        default:
          break;
      }
      // setValue(COMMON_FIELD.TTCHUNG_KHHDON.field, khhdonDefault);
    }
  }, [dispatch, isOpenModal]);

  const checkDisableForm = () => {
    let isTypeAdjustIncDesc = false;
    let isTypeAdjustChangeInfo = false;
    setDisableForm(true);
    if (dataConfirmAction) {
      switch (dataConfirmAction.mode) {
        // Thay thế hóa đơn
        case MODE_INVOICE_ACTION.REPLACE:
          setDisableForm(false);
          break;
        // Điều chỉnh hóa đơn
        case MODE_INVOICE_ACTION.ADJUST:
          switch (dataConfirmAction.typeAdjust) {
            // Tăng, giảm
            case TYPE_ADJUST_INVOICE.INCREASE:
            case TYPE_ADJUST_INVOICE.DECREASE:
              isTypeAdjustIncDesc = true;
              //   setDisableForm(false);
              break;
            // Điều chỉnh thông tin
            case TYPE_ADJUST_INVOICE.CHANGE_INFO:
              //   setDisableForm(true);
              isTypeAdjustChangeInfo = true;
              break;
            default:
              break;
          }
          setDisableForm(true);
          break;
        default:
          break;
      }
      // Cập nhật lại hóa đơn điều chỉnh/thay thế ở trạng thái lưu tạm
      switch (dataConfirmAction.modeEdit) {
        // Thay thế hóa đơn
        case MODE_INVOICE_ACTION.REPLACE:
          setDisableForm(false);
          break;
        // Điều chỉnh hóa đơn
        case MODE_INVOICE_ACTION.ADJUST:
          switch (dataConfirmAction.typeAdjust) {
            // Tăng, giảm
            case TYPE_ADJUST_INVOICE.INCREASE:
            case TYPE_ADJUST_INVOICE.DECREASE:
              isTypeAdjustIncDesc = true;
              //   setDisableForm(false);
              break;
            // Điều chỉnh thông tin
            case TYPE_ADJUST_INVOICE.CHANGE_INFO:
              //   setDisableForm(true);
              isTypeAdjustChangeInfo = true;
              break;
            default:
              break;
          }
          setDisableForm(true);
          break;
        default:
          break;
      }
    } else {
      switch (mode) {
        case issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL:
        case issueInvoiceModeList.VIEW_INVOICE_TICKETS_DETAIL:
        case issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL:
          setDisableForm(true);
          break;
        default:
          setDisableForm(false);
          break;
      }
    }
    setIsTypeAdjustIncDesc(isTypeAdjustIncDesc);
    setIsTypeAdjustChangeInfo(isTypeAdjustChangeInfo);
  };

  // Language Change
  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            ...optionDateLocale.locale,
          },
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            ...optionDateLocale.locale,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  // Action Dispatch
  useEffect(() => {
    if (issueInvoiceCreate && issueInvoiceCreate.success) {
      addToast(t("form.submit.create.invoice.success"), {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(resetCreateIssueInvoice());
      toggleModal(mode);
    }
  }, [addToast, dispatch, issueInvoiceCreate, mode, t, toggleModal]);

  // Action Dispatch
  useEffect(() => {
    if (issueInvoiceEdit && issueInvoiceEdit.success) {
      dispatch(resetEditIssueInvoice());
      if (isReleaseGlobal) {
        setIsReleaseGlobal(false);
        addToast("Gửi phát hành hóa đơn thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        // Nếu có liên kết hóa đơn lẻ và k phải hóa đơn thay thế thì mới tạo hóa đơn điều chỉnh 100%
        if (
          detailIssueInvoice?.passersbyRoot &&
          detailIssueInvoice?.tthdlquan_tchdon === null
        ) {
          dispatch(
            createIssueInvoiceEnterpriseAdjustAll(
              detailIssueInvoice?.passersbyRoot.id
            )
          );
        } else {
          toggleModal(mode, false, true);
        }
      } else {
        addToast(t("form.submit.edit.invoice.success"), {
          appearance: "success",
          autoDismiss: true,
        });
      }
      if (isPage) {
        history.push("/invoice/all");
      } else {
        toggleModal(mode);
      }
    }
  }, [addToast, dispatch, issueInvoiceEdit, mode, t, toggleModal]);

  // Error Dispatch
  useEffect(() => {
    if (errorCreate) {
      addToast(t("form.submit.create.invoice.error"), {
        appearance: "error",
        autoDismiss: true,
      });
      if (errorCreate.code === 422 && errorCreate.fields.length > 0) {
        errorCreate.fields.map(item => {
          let fieldName = item.field;
          switch (item.field) {
            case "ttoan_ltsuat":
              fieldName = PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field;
              break;
            // case "ttoan_lphi":
            //   fieldName = PAYMENT_FIELD.TTOAN_LPHI_OBJ.field;
            //   break;
            case "listInvoiceDetail":
              fieldName = HHDV_FIELD.HHDV_OBJ.field;
              break;
            case "common":
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              break;
          }
          setError(fieldName, { type: "manual", message: item.message });
          addToast(item.message, {
            appearance: "error",
            autoDismiss: true,
          });
        });
      }
      dispatch(resetCreateIssueInvoice());
    }

    if (errorEdit) {
      addToast(errorEdit, {
        appearance: "error",
        autoDismiss: true,
      });
      if (isReleaseGlobal) {
        setIsReleaseGlobal(false);
        addToast("Gửi phát hành hóa đơn thất bại", {
          appearance: "success",
          autoDismiss: true,
        });
      } else {
        addToast(t("form.submit.edit.invoice.error"), {
          appearance: "error",
          autoDismiss: true,
        });
      }

      if (errorEdit.code === 422 && errorEdit.fields.length > 0) {
        errorEdit.fields.map(item => {
          let fieldName = item.field;
          switch (item.field) {
            case "ttoan_ltsuat":
              fieldName = PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field;
              break;
            // case "ttoan_lphi":
            //   fieldName = PAYMENT_FIELD.TTOAN_LPHI_OBJ.field;
            //   break;
            case "listInvoiceDetail":
              fieldName = HHDV_FIELD.HHDV_OBJ.field;
              break;
            case "common":
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              break;
          }
          setError(fieldName, { type: "manual", message: item.message });
          addToast(item.message, {
            appearance: "error",
            autoDismiss: true,
          });
        });
      }
      dispatch(resetEditIssueInvoice());
    }
  }, [
    HHDV_FIELD.HHDV_OBJ.field,
    // PAYMENT_FIELD.TTOAN_LPHI_OBJ.field,
    PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field,
    addToast,
    dispatch,
    errorCreate,
    errorEdit,
    setError,
    t,
  ]);

  const onSentApprove = values => {
    onSubmit(values, true);
  };
  const beforeSendApprove = values => {
    beforeSubmit(values, true);
  };

  const onRelease = values => {
    const nlapData = getValues(
      ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP.field
    )[0];
    const nlap = new Date(nlapData).getFullYear();
    const currentTimeData = currentTime?.data?.year;
    if (nlap < currentTimeData) {
      addToast("Ngày lập thuộc năm cũ. Vui lòng cập nhật lại ngày lập", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    onSubmit(values, false, true);
  };
  const beforeRelease = values => {
    beforeSubmit(values, false, true);
  };

  const onAllowRelease = values => {
    onSubmit(values, false, true, true);
  };
  const beforeAllowRelease = values => {
    beforeSubmit(values, false, true, true);
  };

  const onSubmit = (
    values,
    isSubmit = false,
    isRelease = false,
    isAllowRelease = false
  ) => {
    // Check phát hành sau khi cập nhật/
    setIsReleaseGlobal(isRelease);
    // Điều chỉnh giảm k dc vượt hạn mức điều chỉnh
    if (
      isShowLimitAdjust &&
      Math.abs(values.ttoan_tgtttbso) > detailIssueInvoice?.limit
    ) {
      addToast(
        "Tổng tiền thanh toán bằng số không được vượt hạn mức điều chỉnh",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      return;
    }
    const isSaveInfoCustomer = values.isSaveInfoCustomer;
    const finalData = formatData(values);
    // lưu thông tin kh
    finalData["isSaveInfoCustomer"] = isSaveInfoCustomer;
    // Gửi mail
    finalData["send_mail"] = inputCBSendMailChange ? 1 : 0;
    // Remove thue suat
    if (listPageViewHaveTSUAT.indexOf(pageView) === -1) {
      for (const item of finalData["listInvoiceDetail"]) {
        item["tsuat"] = "";
      }
      finalData["ttoan_ltsuat"] = "";
    }
    // Nếu là hóa đơn điều chỉnh thông tin thì remove thuế suất
    if (isTypeAdjustChangeInfo) {
      for (const item of finalData["listInvoiceDetail"]) {
        item["tsuat"] = "";
      }
      finalData["ttoan_ltsuat"]?.map(t=>{
        return {
          ...t,
          ThTien: 0,
          TThue: 0,
        }
      })
      // finalData["ttoan_ltsuat"] = [
      //   {
      //     TSuat: "0%",
      //     ThTien: 0,
      //     TThue: 0,
      //   },
      // ];
    }
    // list sản phẩm check để tái sử dụng
    const listProduct = values.hhdv_obj
      .filter(item => item.mhhdvu)
      .map(item => {
        return {
          code: item?.mhhdvu,
          name: item?.thhdvu,
          unit: item?.dvtinh,
          price: item?.dgia,
          id_vat: item?.tsuat?.id,
          vat_text: item?.tsuat?.label,
        };
      });
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE:
        finalData["invoice_type"] = "1";
        break;
      case issueInvoicePageViewList.PAGE_SALE_INVOICE_NONE_CODE:
      case issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE:
      case issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE:
        finalData["invoice_type"] = "0";
        break;
      default:
        break;
    }
    finalData.ttchung_shdon = null;
    if (dataConfirmAction) {
      // Lưu lại giá trị để khi thay thế /điều chỉnh xong thì gửi duyệt lun
      if (isSubmit) {
        btnShowFooter?.btnSubmitEdit?.onClick();
      }
      // If role kế toán thì tạo hóa đơn với trạng thái đã duyệt lun
      if (isRoleAccountant) {
        finalData["approve_status"] = APPROVE_STATUS_A;
      }
      // Thay thế hóa đơn
      switch (dataConfirmAction.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          finalData["is_editable"] = detailIssueInvoice?.is_editable;
          dispatch(
            replaceIssueInvoice(
              dataConfirmAction.id,
              listUploadFile.map(item => item.id),
              finalData,
              typeAnother,
              dataConfirmAction.infoTT32
            )
          );
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          dispatch(
            adjustIssueInvoice(
              dataConfirmAction.id,
              listUploadFile.map(item => item.id),
              dataConfirmAction.typeAdjust,
              finalData,
              typeAnother
            )
          );
          break;
        default:
          break;
      }
      // Thay thế hóa đơn
      switch (dataConfirmAction.modeEdit) {
        case MODE_INVOICE_ACTION.REPLACE:
        case MODE_INVOICE_ACTION.ADJUST:
          finalData.adjust_mod = detailIssueInvoice.adjust_mod;
          let auto_sign = isRelease ? 1 : 0;
          if (isRelease) {
            if (isAllowRelease) {
              dispatch(
                editIssueInvoice(
                  finalData,
                  dataDetail.id,
                  typeAnother,
                  auto_sign
                )
              );
            } else {
              dispatch(
                getInvoiceMinDate(
                  detailIssueInvoice?.ttchung_khmshdon,
                  changeYearOfSerial(
                    detailIssueInvoice?.ttchung_khhdon,
                    currentTime?.data?.year.toString()
                  ),
                  detailIssueInvoice?.bu_code
                )
              );
            }
          } else {
            dispatch(editIssueInvoice(finalData, dataDetail.id, typeAnother));
          }
          break;
        default:
          break;
      }
    } else {
      // Gửi duyệt hóa đơn khi tạo hóa đơn lun
      if (isSubmit) {
        setDataInvoiceTemp({
          finalData: finalData,
          typeAnother: typeAnother,
          listProduct: listProduct,
        });
        btnShowFooter?.btnSubmit?.toggleModal &&
          btnShowFooter?.btnSubmit?.toggleModal();
      } else {
        // THêm sản phẩm mới
        dispatch(createListProductInvoice(listProduct));
        switch (mode) {
          case issueInvoiceModeList.CREATE_INVOICE_TICKETS_DETAIL:
          case issueInvoiceModeList.CREATE_VAT_INVOICE_DETAIL:
          case issueInvoiceModeList.CREATE_SALE_INVOICE_DETAIL:
            if (finalData.ttoan_tgtcthue < 0) {
              addToast(
                "Gía trị hóa đơn phải lớn hơn hoặc bằng 0. Vui lòng kiểm tra lại",
                {
                  appearance: "error",
                  autoDismiss: true,
                }
              );
              return;
            }
            // If role kế toán thì tạo hóa đơn với trạng thái đã duyệt lun
            if (isRoleAccountant) {
              finalData["approve_status"] = APPROVE_STATUS_A;
            }
            dispatch(createIssueInvoice(finalData, typeAnother));
            break;
          case issueInvoiceModeList.EDIT_VAT_INVOICE_DETAIL:
          case issueInvoiceModeList.EDIT_SALE_INVOICE_DETAIL:
          case issueInvoiceModeList.EDIT_INVOICE_TICKETS_DETAIL:
          case issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL:
          case issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL:
            let auto_sign = isRelease ? 1 : 0;
            if (isRelease) {
              if (isAllowRelease) {
                dispatch(
                  editIssueInvoice(
                    finalData,
                    dataDetail.id,
                    typeAnother,
                    auto_sign
                  )
                );
              } else {
                dispatch(
                  getInvoiceMinDate(
                    detailIssueInvoice?.ttchung_khmshdon,
                    changeYearOfSerial(
                      detailIssueInvoice?.ttchung_khhdon,
                      currentTime?.data?.year.toString()
                    ),
                    detailIssueInvoice?.bu_code
                  )
                );
              }
            } else {
              dispatch(editIssueInvoice(finalData, dataDetail.id, typeAnother));
            }
            break;
          default:
            break;
        }
      }
    }
  };

  const beforeSubmit = (
    values,
    isSubmit = false,
    isRelease = false,
    isAllowRelease = false
  ) => {
    // Remove những hàng hóa dịch vụ không hợp lệ ( K có tên hàng hóa)
    const totalHHDVCount = fieldsHHDV.length;
    const errorHHDV = values?.hhdv_obj;
    if (errorHHDV) {
      let listIndexRemove = [];
      errorHHDV.forEach((value, i) => {
        listIndexRemove.push(Number(i));
      });
      const errorHHDVCount = errorHHDV?.filter(item => item.thhdvu).length;
      if (
        Object.keys(values).length === 1 &&
        values?.hhdv_obj &&
        errorHHDVCount < totalHHDVCount
      ) {
        if (listIndexRemove) {
          const currentList = getValues(HHDV_FIELD.HHDV_OBJ.field);
          const filtered = currentList.filter(function (value, index, arr) {
            return !listIndexRemove.includes(index);
          });
          setValue(HHDV_FIELD.HHDV_OBJ.field, filtered, {
            shouldValidate: true,
          });
          autoSumGroupAll();
          setTimeout(() => {
            handleSubmit(async data =>
              onSubmit(data, isSubmit, isRelease, isAllowRelease)
            )();
          });
        }
      }
    }
  };

  const getKhhdDefault = () => {
    if (detailIssueInvoice && isOpenModal) {
      return detailIssueInvoice
        ? detailIssueInvoice?.ttchung_khhdon?.substring(
            0,
            detailIssueInvoice?.ttchung_khhdon.length - 2
          )
        : khhdonDefault;
    }
    return khhdonDefault;
  };

  const formatData = values => {
    const finalData = {};

    TOTAL_FIELD_ARRAY.map(item => {
      const itemField = TOTAL_FIELD[item];
      const valueField = values[itemField.field];
      switch (itemField.type) {
        case "object":
          finalData[itemField.field] = valueField;
          break;
        case "text":
          //   if (itemField.field === "ttchung_khhdon") {
          //     finalData[itemField.field] = `${getKhhdDefault()}${
          //       valueField?.value ? valueField.label : ""
          //     }`;
          //   } else {
          finalData[itemField.field] = valueField || "";
          //   }
          break;
        case "number":
          finalData[itemField.field] = Number(valueField);
          break;
        case "select":
          finalData[itemField.field] = valueField?.value
            ? valueField.value
            : "";
          break;
        case "date":
          if (itemField.field === COMMON_FIELD.TTCHUNG_NLAP.field) {
            finalData[itemField.field] = convertDate(
              valueField[0],
              "YYYY-MM-DD"
            );
          } else {
            finalData[itemField.field] = convertDate(valueField[0]);
          }
          break;
        case "field_array":
          finalData[itemField.fieldReal] = [];

          const listField = itemField.list;
          const arrayField = [];
          for (const key in listField) {
            arrayField.push(key);
          }
          let stt = 0;
          finalData[itemField.fieldReal] =
            valueField &&
            valueField.map(fieldChild => {
              stt = stt + 1;
              const finalDataFieldArray = {};
              arrayField.map(y => {
                const itemFieldArray = listField[y];
                const valueFieldArray = fieldChild[itemFieldArray.field];
                if (y === "STT") {
                  finalDataFieldArray[itemFieldArray.fieldReal] = stt;
                } else {
                  // console.log(itemFieldArray.type, "itemFieldArray.type");
                  switch (itemFieldArray.type) {
                    case "text":
                      finalDataFieldArray[itemFieldArray.fieldReal] =
                        valueFieldArray || "";
                      break;
                    case "number":
                      finalDataFieldArray[itemFieldArray.fieldReal] =
                        Number(valueFieldArray);
                      break;
                    case "select":
                      if (
                        itemFieldArray.fieldReal === "tsuat" ||
                        itemFieldArray.fieldReal === "TSuat"
                      ) {
                        finalDataFieldArray[itemFieldArray.fieldReal] =
                          valueFieldArray && valueFieldArray.label;
                      } else {
                        finalDataFieldArray[itemFieldArray.fieldReal] =
                          valueFieldArray?.value || "";
                      }
                      // Luu thêm giá trị thuế suất vào db
                      if (itemFieldArray.fieldReal === "tsuat") {
                        finalDataFieldArray["tsuat_value"] =
                          valueFieldArray?.value;
                      }
                      break;
                    case "date":
                      finalDataFieldArray[itemFieldArray.fieldReal] =
                        convertDate(valueFieldArray[0]);
                      break;
                    default:
                      break;
                  }
                }
              });
              return finalDataFieldArray;
            });
          break;
        default:
          break;
      }
    });

    return finalData;
  };

  const defaultValueLineHHDV = {
    [HHDV_FIELD.HHDV_OBJ.list.TCHAT.field]: OPTION_HHDV_TCHAT[0],
    [HHDV_FIELD.HHDV_OBJ.list.STT.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.DVTINH.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.SLUONG.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.DGIA.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.THTIEN.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: listVat[0],
    [HHDV_FIELD.HHDV_OBJ.list.TTKHAC.field]: "",
  };

  const defaultValueLineTTOAN_LTSUAT = {
    [PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list.TSUAT.field]: {
      value: "",
      label: "",
    },
    [PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list.THTIEN.field]: "",
    [PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list.TTHUE.field]: "",
  };

  //   const defaultValueLineTTOAN_LPHI = {
  //     [PAYMENT_FIELD.TTOAN_LPHI_OBJ.list.TLPHI.field]: "",
  //     [PAYMENT_FIELD.TTOAN_LPHI_OBJ.list.TPHI.field]: "",
  //   };

  const addNewLineHHDV = () => {
    appendHHDV(defaultValueLineHHDV);
    // setTimeout(() => {
    // });
  };

  const addNewRowHHDVHandle = () => {
    addNewLineHHDV();
    setIsAddNewLine(true);
    setIsLoadTable(true);
  };

  const removeNewRowHHDVHandle = index => {
    removeHHDV(index);
    setIsRemoveLine(true);
    setIsLoadTable(true);
  };

  const addNewLineTTOAN_LTSUAT = () => {
    appendTTOAN_LTSUAT(defaultValueLineTTOAN_LTSUAT);
  };
  //   const addNewLineTTOAN_LPHI = () => {
  //     appendTTOAN_LPHI(defaultValueLineTTOAN_LPHI);
  //   };

  const caculateHHDV = (fieldArray, index, fieldChild, customValue) => {
    if (isFirstLoad) {
      setIsFirstLoad(false);
      return;
    }
    const value = getValues(HHDV_FIELD.HHDV_OBJ.field);
    const HDDV_OBJ = HHDV_FIELD.HHDV_OBJ;
    const THHDVU = HDDV_OBJ.list.THHDVU.field;
    const MHHDVU = HDDV_OBJ.list.MHHDVU.field;
    const SLUONG = HDDV_OBJ.list.SLUONG.field;
    const DVTINH = HDDV_OBJ.list.DVTINH.field;
    const DGIA = HDDV_OBJ.list.DGIA.field;
    const THTIEN = HDDV_OBJ.list.THTIEN.field;
    const TSUAT = HDDV_OBJ.list.TSUAT.field;
    const TCHAT = HDDV_OBJ.list.TCHAT.field;
    const TLCKHAU = HDDV_OBJ.list.TLCKHAU.field;
    const STCKHAU = HDDV_OBJ.list.STCKHAU.field;
    let currentValue = {};
    if (value) {
      currentValue = value[index];
      switch (fieldChild) {
        case TSUAT:
          if (
            currentValue[TCHAT].value === TCHAT_VALUES.DISCOUNT &&
            fieldChild === THTIEN
          ) {
            let ckhaucthue = currentValue[THTIEN]; // thành tiền chiết khầu chưa thuế
            let ckhauThue = Math.round(
              (currentValue[THTIEN] * currentValue[TSUAT].value) / 100
            ); // số tiền thuế của chiết khầu
            currentValue[STCKHAU] = ckhaucthue + ckhauThue; // số tiền chiết khấu
            setValue(
              `${HDDV_OBJ.field}.${index}.${STCKHAU}`,
              Number(currentValue[STCKHAU]),
              {
                shouldValidate: true,
              }
            );
          }
          autoSumGroupAll();
        case THTIEN:
          if (
            currentValue[TCHAT].value === TCHAT_VALUES.DISCOUNT &&
            fieldChild === THTIEN
          ) {
            let ckhaucthue = currentValue[THTIEN]; // thành tiền chiết khầu chưa thuế
            let ckhauThue = Math.round(
              (currentValue[THTIEN] * currentValue[TSUAT].value) / 100
            ); // số tiền thuế của chiết khầu
            currentValue[STCKHAU] = ckhaucthue + ckhauThue; // số tiền chiết khấu
            setValue(
              `${HDDV_OBJ.field}.${index}.${STCKHAU}`,
              Number(currentValue[STCKHAU]),
              {
                shouldValidate: true,
              }
            );
            autoSumGroupAll();
          }
          break;
        case DGIA:
        case SLUONG:
          // IF co nhap so luong va don gia
          if (currentValue[SLUONG] && currentValue[DGIA]) {
            currentValue[THTIEN] = financial(
              Number(currentValue[SLUONG]) * Number(currentValue[DGIA]),
              2
            );
          } else if (!currentValue[SLUONG] || !currentValue[DGIA]) {
            // IF chưa nhap so luong hoac don gia
            currentValue[THTIEN] = "";
          }
          // Nếu là Hóa đơn điều chỉnh thì k tính số lượng
          //   if (
          //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.INCREASE ||
          //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE
          //   ) {
          //     currentValue[THTIEN] = Number(currentValue[DGIA]) * 1;
          //   }
          setValue(
            `${HDDV_OBJ.field}.${index}.${THTIEN}`,
            Number(currentValue[THTIEN]),
            {
              shouldValidate: true,
            }
          );
          autoSumGroupAll();
          break;
        case STCKHAU:
          //   autoSumGroupAll();
          break;
        case TCHAT:
          if (
            currentValue[TCHAT].value === TCHAT_VALUES.GOODS ||
            currentValue[TCHAT].value === TCHAT_VALUES.PROMOTION
          ) {
            if (!currentValue[TSUAT].value) {
              currentValue[TSUAT] = OPTION_HHDV_TSUAT[0];
            }
            currentValue[SLUONG] = currentValue[SLUONG]
              ? currentValue[SLUONG]
              : 0;
            currentValue[DGIA] = currentValue[DGIA] ? currentValue[DGIA] : 0;
          }
          if (
            currentValue[TCHAT].value !== TCHAT_VALUES.GOODS &&
            currentValue[TCHAT].value !== TCHAT_VALUES.PROMOTION
          ) {
            currentValue[SLUONG] = "";
            currentValue[DGIA] = "";
            currentValue[DVTINH] = "";
            currentValue[THTIEN] = "";
            currentValue[TSUAT] = {
              value: "",
              label: "",
            };
            currentValue[MHHDVU] = "";
          }
          if (currentValue[TCHAT].value !== TCHAT_VALUES.DISCOUNT) {
            currentValue[STCKHAU] = "";
            currentValue[TLCKHAU] = "";
          }
          if (currentValue[TCHAT].value === TCHAT_VALUES.DISCOUNT) {
            currentValue[STCKHAU] = 0;
            currentValue[TSUAT] = OPTION_HHDV_TSUAT[0];
            currentValue[SLUONG] = 1;
            currentValue[DGIA] = 1;
          }
          setValue(HDDV_OBJ.field, value, {
            shouldValidate: true,
          });
          autoSumGroupAll();
          break;
        case MHHDVU:
        case THHDVU: //
          const tchat = currentValue.tchat.value;
          const product = customValue;
          // load thông tin khi chọn hàng hóa dịch vụ có sẵn
          if (product) {
            switch (tchat) {
              case TCHAT_VALUES.GOODS:
              case TCHAT_VALUES.PROMOTION:
                //
                if (!currentValue[SLUONG]) {
                  currentValue[SLUONG] = 0;
                }
                if (fieldChild === THHDVU) {
                  currentValue[MHHDVU] = product.code;
                }
                if (fieldChild === MHHDVU) {
                  currentValue[THHDVU] = product.name;
                }

                currentValue[DVTINH] = product.unit;
                currentValue[DGIA] = Number(product.price);

                // Hóa đơn VAT , tem phiếu mí có thuế suất (nếu k có thì mặc định đầu tiên,
                // do sản phẩm được tạo bên hóa đơn bán hàng k có thuế suất)
                switch (pageView) {
                  case issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE:
                  case issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE:
                  case issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE:
                  case issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE:
                    let tsuat = null;
                    if (product.id_vat) {
                      tsuat = OPTION_HHDV_TSUAT.find(
                        item => Number(item.id) === Number(product.id_vat)
                      );
                    } else if (product.vat_text) {
                      tsuat = {
                        value: Number(
                          product.vat_text.replace(/KHAC:|.00%/g, "")
                        ),
                        label: product.vat_text,
                      };
                    }
                    currentValue[TSUAT] = tsuat ? tsuat : OPTION_HHDV_TSUAT[0];
                    break;
                  default:
                    break;
                }

                if (currentValue[SLUONG] && currentValue[DGIA]) {
                  currentValue[THTIEN] = financial(
                    Number(currentValue[SLUONG]) * Number(currentValue[DGIA]),
                    2
                  );
                } else if (!currentValue[SLUONG] || !currentValue[DGIA]) {
                  // IF chưa nhap so luong hoac don gia
                  currentValue[THTIEN] = "";
                }
                break;
              case TCHAT_VALUES.DISCOUNT:
                if (fieldChild === THHDVU) {
                  currentValue[MHHDVU] = product.code;
                }
                if (fieldChild === MHHDVU) {
                  currentValue[THHDVU] = product.name;
                }
                break;
              case TCHAT_VALUES.EXPLAIN:
                break;
              default:
                break;
            }
            setValue(HDDV_OBJ.field, value, {
              shouldValidate: true,
            });
            autoSumGroupAll();
          }
          break;
        default:
          break;
      }
    }
  };

  const autoSumGroupAll = () => {
    console.log("autoSumGroupAll");
    const valueHHDV = getValues(HHDV_FIELD.HHDV_OBJ.field);
    //Thông tin tổng hợp của mỗi loại thuế suất
    const groupTsuat = {};
    let ttoan_ttcktmai = 0; //Tổng tiền chiết khấu thương mại
    let ttoan_tgtcthue = 0; //Tổng tiền chưa thuế
    let ttoan_tgtthue = 0; //Tổng tiền thuế
    let ttoan_tgtttbso = 0; //Tổng tiền thanh toán bằng số
    for (const item of valueHHDV) {
      const tsuatLabel = item.tsuat ? item.tsuat.label : "";
      const tsuatValue = item.tsuat ? item.tsuat.value : 0;
      const tchat = item.tchat.value;
      // Tính chất là hàng hóa dịch vụ/khuyến mãi
      if (tchat === "1" || tchat === "2" || tchat === "3") {
        let ttoan_tthue = 0;
        let thtien = 0;
        let operators = tchat === "3" ? "-" : "+";
        //Auto fill Thông tin tổng hợp của mỗi loại thuế suất
        thtien = item.thtien ? item.thtien : 0;
        ttoan_tthue = Math.round((item.thtien * tsuatValue) / 100);
        // Group thuế suất
        let keyGroup =
          tsuatLabel === "KCT" || tsuatLabel === "KKKNT"
            ? tsuatLabel
            : tsuatValue;

        if (groupTsuat[keyGroup]) {
          groupTsuat[keyGroup].ttoan_thtien = operatorsHelper[operators](
            groupTsuat[keyGroup].ttoan_thtien,
            Number(thtien)
          );
          groupTsuat[keyGroup].ttoan_tthue = operatorsHelper[operators](
            groupTsuat[keyGroup].ttoan_tthue,
            Number(ttoan_tthue)
          );
        } else {
          // Trường hợp lần tsuat lần đầu
          groupTsuat[keyGroup] = {
            valueOption: String(item.tsuat?.value)
              ? item.tsuat
              : {
                  value: "",
                  label: "",
                },
            ttoan_thtien: Number(thtien),
            ttoan_tthue: Number(ttoan_tthue),
          };
        }

        //Tổng tiền chưa thuế
        ttoan_tgtcthue = financial(
          operatorsHelper[operators](Number(ttoan_tgtcthue), Number(thtien)),
          2
        );
        //Tổng tiền thuế
        ttoan_tgtthue = financial(
          operatorsHelper[operators](
            Number(ttoan_tgtthue),
            Number(ttoan_tthue)
          ),
          2
        );
        // //Tổng tiền thanh toán bằng số
        // ttoan_tgtttbso = ttoan_tgtttbso + (Number(thtien) + ttoan_tthue);
      }
      if (tchat === "3") {
        //Tổng tiền chiết khấu thương mại
        ttoan_ttcktmai = ttoan_ttcktmai + Number(item.stckhau);
      }
    }
    const sumTsuatList = [];
    // Auto fill Thông tin tổng hợp của mỗi loại thuế suất
    for (const item in groupTsuat) {
      sumTsuatList.push({
        ttoan_tsuat: groupTsuat[item].valueOption,
        ttoan_thtien: groupTsuat[item].ttoan_thtien,
        ttoan_tthue: Math.round(groupTsuat[item].ttoan_tthue),
      });
    }
    if (sumTsuatList.length > 0) {
      setValue("ttoan_ltsuat_obj", sumTsuatList);
    } else {
      setValue("ttoan_ltsuat_obj", [
        {
          ttoan_tsuat: {
            value: "",
            label: "",
          },
          ttoan_thtien: "",
          ttoan_tthue: "",
        },
      ]);
    }
    ttoan_tgtthue = Math.round(ttoan_tgtthue);
    //Tổng tiền chưa thuế
    setValue("ttoan_tgtcthue", ttoan_tgtcthue);
    //Tổng tiền thuế
    setValue("ttoan_tgtthue", ttoan_tgtthue);
    //Tổng tiền chiết khấu thương mại
    setValue("ttoan_ttcktmai", ttoan_ttcktmai);
    //Tổng tiền thanh toán bằng số
    // ttoan_tgtttbso = financial(
    //   ttoan_tgtcthue + ttoan_tgtthue - ttoan_ttcktmai,
    //   2
    // );
    ttoan_tgtttbso = financial(
      Number(ttoan_tgtcthue) + Number(ttoan_tgtthue),
      2
    );
    setValue("ttoan_tgtttbso", ttoan_tgtttbso);
    //Tổng tiền thanh toán bằng chữ
    let ttoan_tgtttbchu = formatTienFinal(
      ttoan_tgtttbso,
      getValues("ttchung_dvtte")?.value
    );
    ttoan_tgtttbchu = fixConvertNumberToText(ttoan_tgtttbchu);
    ttoan_tgtttbchu =
      ttoan_tgtttbchu.charAt(0).toUpperCase() + ttoan_tgtttbchu.slice(1);
    let textChange = "";
    switch (dataConfirmAction?.typeAdjust) {
      case TYPE_ADJUST_INVOICE.INCREASE:
        textChange = "Điều chỉnh tăng ";
        break;
      case TYPE_ADJUST_INVOICE.DECREASE:
        textChange = "Điều chỉnh giảm ";
        break;
      default:
        break;
    }
    setValue("ttoan_tgtttbchu", textChange + ttoan_tgtttbchu);
  };

  // Delay when MST người bán  Change
  const [disableBtnInfoByTax, setDisableBtnInfoByTax] = useState(true);
  const [inputMSTChange, setInputMSTChange] = useState(null);
  const [inputCBSendMailChange, setInputCBSendMailChange] = useState(false);

  useEffect(() => {
    const delayDebounceTAXFn = setTimeout(() => {
      if (inputMSTChange) {
        if (inputMSTChange.length === 10 || inputMSTChange.length === 14) {
          dispatch(getEnterpriseByTaxCode(inputMSTChange));
        }
      }
    }, 500);
    return () => clearTimeout(delayDebounceTAXFn);
  }, [inputMSTChange]);

  useEffect(() => {
    if (!loadDingEnterpriseByTaxCode) {
      setDisableBtnInfoByTax(false);
    }
  }, [loadDingEnterpriseByTaxCode]);

  // Delay when input HDDV Change
  const [inputValueChange, setInputValueChange] = useState(null);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (inputValueChange) {
        caculateHHDV(
          inputValueChange.fieldArray,
          inputValueChange.index,
          inputValueChange.fieldChild
        );
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [inputValueChange]);
  //
  // We start with an empty list of items.
  const [listSizePerPage, setListSizePerPage] = useState([5, 20, 25, 50, 100]);
  const [itemsPerPage, setItemsPerPage] = useState(listSizePerPage[0]);
  const [currentItemsHHDV, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [isAddNewLine, setIsAddNewLine] = useState(false);
  const [isRemoveLine, setIsRemoveLine] = useState(false);
  const [isChangeSizePage, setIsChangeSizePage] = useState(false);

  const [isLoadTable, setIsLoadTable] = useState(false);

  const initNewPageItem = () => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(fieldsHHDV.slice(itemOffset, endOffset));
    let pageCount = Math.ceil(fieldsHHDV.length / itemsPerPage);
    setPageCount(pageCount);

    if (isChangeSizePage) {
      changeToPage(0);
      //   setIsChangeSizePage(false);
    } else {
      // Thêm item có page mới thì sang page mới
      if (isAddNewLine) {
        // setIsLoadTable(true);
        setIsAddNewLine(false);
        changeToPage(pageCount - 1);
      }
      // Xóa item
      if (isRemoveLine) {
        setIsRemoveLine(false);
        // Page hiện tại lớn hơn số page hiện có
        if (pageCount === currentPage) {
          // Lùi 1 page
          changeToPage(currentPage - 1);
        } else {
          // giữ nguyên page
          changeToPage(currentPage);
        }
      }
    }
  };

  useEffect(() => {
    if (currentItemsHHDV) {
      setIsLoadTable(false);
    }
  }, [currentItemsHHDV]);

  useEffect(() => {
    if (!isLoadTable && isOpenModal && modalTable && modalTable.current) {
      let scroll = null;
      if (isChangeSizePage) {
        setIsChangeSizePage(false);
        scroll = 0;
      } else {
        scroll = modalTable.current.scrollHeight;
      }
      modalTable.current.scrollTop = scroll;
    }
  }, [isLoadTable]);

  useEffect(() => {
    if (pageCount) {
      //   // Thêm item có page mới thì sang page mới
      //   if (isAddNewLine || isRemoveLine) {
      //     // setIsLoadTable(true);
      //     setIsAddNewLine(false);
      //     setIsRemoveLine(false);
      //     changeToPage(pageCount - 1);
      //   }
    }
  }, [pageCount]);

  useEffect(() => {
    // Fetch items from another resources.
    if (isOpenModal) {
      initNewPageItem();
    }
  }, [itemOffset, itemsPerPage, isOpenModal]);

  // Invoke when user click to request another page.
  const handlePageClick = event => {
    setIsLoadTable(true);
    changeToPage(event.selected);
  };

  const changeToPage = page => {
    const newOffset = (page * itemsPerPage) % fieldsHHDV.length;
    setItemOffset(newOffset);
    setCurrentPage(page);
  };

  // setDefaultConfigField
  useEffect(() => {
    if (fieldsHHDV && isOpenModal) {
      initNewPageItem();
    }
  }, [fieldsHHDV, isOpenModal]);

  const generateTable = (
    fieldContanst,
    listContanst,
    fieldsArray,
    removeFunc,
    addFunc,
    isAuto = false,
    styleTable = {}
  ) => {
    //
    let fieldDisableConfig = {};
    if (!isEditableAdjustReplace) {
      fieldDisableConfig = FIELD_DISABLE_CONFIG[fieldContanst];
    }
    return (
      <React.Fragment>
        <div
          ref={modalTable}
          className="custom-table-border hhdv-table"
          style={{ ...styleTable }}
        >
          <Table className="table  table-bordered">
            <thead>
              <tr>
                <th className="text-center" style={{ width: "20px" }}>
                  STT
                </th>
                {Object.entries(listContanst)
                  .filter(([k, v]) => !v.isHide && checkShowWithPageView(v))
                  .map(([key, value]) => {
                    return (
                      <th
                        style={{ width: value.width }}
                        className="text-center"
                        key={key}
                      >
                        {t(`form.${value.field}`)}{" "}
                        {value.required && (
                          <span className="text-danger"> (*)</span>
                        )}
                      </th>
                    );
                  })}
                {!isAuto && isEditableAdjustReplace && (
                  <th style={{ width: "20px", textAlign: "center" }}>
                    {!disableForm && !isTypeAdjustIncDesc && (
                      <i
                        title="Thêm hàng hóa (F2)"
                        onClick={addFunc}
                        className="fas fa-plus  text-success label-icon"
                        style={{ cursor: "pointer" }}
                      ></i>
                    )}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {fieldsArray.map((field, indexOfItem) => {
                let index = currentPage * itemsPerPage + indexOfItem;
                // console.log(
                //   "🚀 ~ file: DetailInvoice.js ~ line 1956 ~ {fieldsArray.map ~ index",
                //   index
                // );
                // console.log(
                //   "🚀 ~ file: DetailInvoice.js ~ line 1956 ~ {fieldsArray.map ~ stt",
                //   index + 1
                // );
                // console.log("🚀 ~ ---------------------------");
                // if (watch(`hhdv_obj`)) {
                //   console.log("value", watch(`hhdv_obj`)[index]);
                // }
                const fieldMain = fieldContanst;
                const listField = listContanst;
                const arrayField = [];
                for (const key in listField) {
                  if (
                    !listField[key].isHide &&
                    checkShowWithPageView(listField[key])
                  ) {
                    arrayField.push(key);
                  }
                }
                const tdStyle = {
                  display: "table-cell",
                  verticalAlign: "bottom",
                };

                if (
                  watch(`hhdv_obj`) === undefined ||
                  watch(`hhdv_obj`)[index] === undefined
                ) {
                  return <React.Fragment></React.Fragment>;
                }
                return (
                  !isLoadTable && (
                    <tr key={field.key}>
                      <td>{index + 1}</td>
                      {arrayField.map(item => {
                        const itemField = listField[item];
                        let watchDisable = disableForm;
                        if (!watchDisable) {
                          if (fieldMain === HHDV_FIELD.HHDV_OBJ.field) {
                            switch (itemField.field) {
                              case HHDV_FIELD.HHDV_OBJ.list.TCHAT.field:
                              case HHDV_FIELD.HHDV_OBJ.list.THHDVU.field:
                                watchDisable = false;
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.THTIEN.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                  "3";
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                              case HHDV_FIELD.HHDV_OBJ.list.DGIA.field:
                              //   case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                              case HHDV_FIELD.HHDV_OBJ.list.DVTINH.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2";
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.TSUAT.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "3";
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "3";
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field:
                              case HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field:
                                watchDisable = true;
                                break;
                              default:
                                break;
                            }
                          } else {
                            watchDisable = true;
                          }
                        } else {
                          // Nếu điều chỉnh hóa đơn tăng giảm thì chỉ cho chỉnh số lượng và đơn giá
                          if (
                            isTypeAdjustIncDesc &&
                            fieldMain === HHDV_FIELD.HHDV_OBJ.field
                          ) {
                            //   switch (itemField.field) {
                            //     //   case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                            //     case HHDV_FIELD.HHDV_OBJ.list.DGIA.field:
                            //       if (
                            //         (watch(`hhdv_obj`)[index]["tchat"].value ===
                            //           "1" ||
                            //           watch(`hhdv_obj`)[index]["tchat"].value ===
                            //             "2") &&
                            //         isTypeAdjustIncDesc
                            //       )
                            //         watchDisable = false;
                            //       break;
                            //     default:
                            //       break;
                            //   }
                            switch (itemField.field) {
                              case HHDV_FIELD.HHDV_OBJ.list.TCHAT.field:
                              case HHDV_FIELD.HHDV_OBJ.list.THHDVU.field:
                                watchDisable = false;
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.THTIEN.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                  "3";
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                              case HHDV_FIELD.HHDV_OBJ.list.DGIA.field:
                              //   case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                              case HHDV_FIELD.HHDV_OBJ.list.DVTINH.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2";
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.TSUAT.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "3";
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "3";
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field:
                              case HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field:
                                watchDisable = true;
                                break;
                              default:
                                break;
                            }
                          }
                          // Nếu điều chỉnh hóa đơn thay đổi thông tin thì cho nhập hàng hóa
                          if (
                            isTypeAdjustChangeInfo &&
                            fieldMain === HHDV_FIELD.HHDV_OBJ.field
                          ) {
                            switch (itemField.field) {
                              //   case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                              case HHDV_FIELD.HHDV_OBJ.list.THHDVU.field:
                                watchDisable = false;
                                break;
                              default:
                                break;
                            }
                          }
                        }
                        let allowNegative = false;
                        // Disable field theo config
                        if (
                          fieldDisableConfig &&
                          fieldDisableConfig[itemField.field]
                        ) {
                          watchDisable = fieldDisableConfig[itemField.field];
                          if (
                            watch(`hhdv_obj`)[index]["tchat"].value === "4" &&
                            itemField.field === "thhdvu"
                          ) {
                            watchDisable = false;
                          }
                        }
                        switch (itemField.type) {
                          case "text":
                          case "number":
                            // điều chỉnh giảm thi  cho nhập đơn giá/số lượng âm
                            if (
                              (itemField.field === "sluong" ||
                                itemField.field === "dgia" ||
                                itemField.field === "stckhau" ||
                                itemField.field === "ttoan_tsuat" ||
                                itemField.field === "ttoan_thtien" ||
                                itemField.field === "ttoan_tthue" ||
                                itemField.field === "thtien") &&
                              dataConfirmAction?.typeAdjust ===
                                TYPE_ADJUST_INVOICE.DECREASE
                            ) {
                              allowNegative = true;
                            }
                            return (
                              <td
                                style={tdStyle}
                                key={item}
                                className="custom-form-table"
                              >
                                {generateInputFieldArray(
                                  t(`form.${itemField.field}`),
                                  itemField.required,
                                  itemField.type,
                                  errors,
                                  touchedFields,
                                  fieldMain,
                                  index,
                                  itemField.field,
                                  !itemField.disabled
                                    ? t("placeholder.enter", {
                                        title: t(`form.${itemField.field}`),
                                      })
                                    : "",
                                  register,
                                  watchDisable,
                                  setInputValueChange,
                                  control,
                                  itemField.isThousandSeparator,
                                  allowNegative,
                                  OPTION_GROUP,
                                  caculateHHDV,
                                  {
                                    [EXTRA_BUTTON.ADD_PRODUCT]:
                                      buttonAddProduct(),
                                  },
                                  watch
                                )}
                              </td>
                            );
                          case "select":
                            return (
                              <td key={item} className="custom-form-table">
                                {generateSelectFieldArray(
                                  watch,
                                  t(`form.${itemField.field}`),
                                  itemField.required,
                                  errors,
                                  fieldMain,
                                  index,
                                  itemField.field,
                                  !itemField.disabled
                                    ? t("placeholder.select")
                                    : "",
                                  watchDisable,
                                  control,
                                  OPTION_GROUP[itemField.field],
                                  caculateHHDV,
                                  "bottom",
                                  itemField.allowCreate
                                )}
                              </td>
                            );
                          case "date":
                            return (
                              <td key={item}>
                                <FormGroup className="mb-2">
                                  {generateDateField(
                                    t(`form.${itemField.field}`),
                                    "",
                                    itemField.required,
                                    errors,
                                    itemField.field,
                                    "DD/MM/YYYY",
                                    itemField.disabled,
                                    control,
                                    optionDateLocale
                                  )}
                                </FormGroup>
                              </td>
                            );
                          default:
                            break;
                        }
                      })}
                      {!isAuto && isEditableAdjustReplace && (
                        <td>
                          {!disableForm &&
                          !isTypeAdjustIncDesc &&
                          fieldsHHDV.length > 1 ? (
                            <React.Fragment>
                              <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                                {/* {fieldsArray.length > 1 && ( */}
                                <i
                                  title="Xóa bỏ"
                                  onClick={() => {
                                    removeFunc(index);
                                    setTimeout(() => {
                                      autoSumGroupAll();
                                    });
                                  }}
                                  className="mdi mdi-trash-can  text-danger font-size-18"
                                  style={{ cursor: "pointer" }}
                                />
                                {/* )} */}
                              </div>
                            </React.Fragment>
                          ) : !disableForm &&
                            dataConfirmAction?.typeAdjust ===
                              TYPE_ADJUST_INVOICE.DECREASE &&
                            fieldsHHDV.length > 1 ? (
                            <React.Fragment>
                              <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                                {/* {fieldsArray.length > 1 && ( */}
                                <i
                                  title="Xóa bỏ"
                                  onClick={() => {
                                    removeFunc(index);
                                    setTimeout(() => {
                                      autoSumGroupAll();
                                    });
                                  }}
                                  className="mdi mdi-trash-can  text-danger font-size-18"
                                  style={{ cursor: "pointer" }}
                                />
                                {/* )} */}
                              </div>
                            </React.Fragment>
                          ) : (
                            <React.Fragment></React.Fragment>
                          )}
                        </td>
                      )}
                    </tr>
                  )
                );
              })}
            </tbody>
          </Table>
        </div>
        <div
          className="mt-2 mb-2 d-flex"
          style={{ justifyContent: "space-between" }}
        >
          <div>
            <div>
              Tổng cộng: {fieldsHHDV.length}
              <div className="text-danger">
                * Vui lòng nhập ít nhất 1 dòng hợp lệ
              </div>
            </div>
          </div>
          <div className="d-flex gap-2">
            <ReactPaginate
              className="table-paginate"
              nextLabel=" >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={4}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              forcePage={currentPage}
              previousLabel="< "
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
            <select
              value={itemsPerPage}
              disabled={true}
              onChange={e => {
                setItemsPerPage(Number(e.target.value));
                setIsLoadTable(true);
                setIsChangeSizePage(true);
              }}
              style={{
                width: "fit-content",
                height: "37px",
              }}
            >
              {listSizePerPage.map(item => {
                return (
                  <option key={item} value={item}>
                    {item}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const generateTableSecond = (
    fieldContanst,
    listContanst,
    fieldsArray,
    removeFunc,
    addFunc,
    isAuto = false,
    styleTable = {}
  ) => {
    return (
      <div
        className="custom-table-border tsuat-table"
        style={{ ...styleTable }}
      >
        <Table className="table  table-bordered">
          <thead>
            <tr>
              <th className="text-center" style={{ width: "20px" }}>
                STT
              </th>
              {Object.entries(listContanst)
                .filter(([k, v]) => !v.isHide && checkShowWithPageView(v))
                .map(([key, value]) => {
                  return (
                    <th
                      style={{
                        width: value.width,
                      }}
                      className="text-center"
                      key={key}
                    >
                      {t(`form.${value.field}`)}{" "}
                      {value.required && (
                        <span className="text-danger"> (*)</span>
                      )}
                    </th>
                  );
                })}
              {!isAuto && <th style={{ width: "20px" }}></th>}
            </tr>
          </thead>
          <tbody>
            {fieldsArray.map((field, index) => {
              const fieldMain = fieldContanst;
              const listField = listContanst;
              const arrayField = [];
              for (const key in listField) {
                if (
                  !listField[key].isHide &&
                  checkShowWithPageView(listField[key])
                ) {
                  arrayField.push(key);
                }
              }
              const tdStyle = {
                display: "table-cell",
                verticalAlign: "bottom",
              };
              return (
                <tr key={field.key}>
                  <td>{index + 1}</td>
                  {arrayField.map(item => {
                    const itemField = listField[item];
                    let watchDisable = disableForm;
                    if (!watchDisable) {
                      watchDisable = true;
                    }
                    let allowNegative = true;
                    switch (itemField.type) {
                      case "text":
                      case "number":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateInputFieldArray(
                              t(`form.${itemField.field}`),
                              itemField.required,
                              itemField.type,
                              errors,
                              touchedFields,
                              fieldMain,
                              index,
                              itemField.field,
                              !itemField.disabled
                                ? t("placeholder.enter", {
                                    title: t(`form.${itemField.field}`),
                                  })
                                : "",
                              register,
                              watchDisable,
                              setInputValueChange,
                              control,
                              itemField.isThousandSeparator,
                              allowNegative,
                              null,
                              null,
                              null,
                              watch
                            )}
                          </td>
                        );
                      case "select":
                        return (
                          <td key={item}>
                            {generateSelectFieldArray(
                              watch,
                              t(`form.${itemField.field}`),
                              itemField.required,
                              errors,
                              fieldMain,
                              index,
                              itemField.field,
                              !itemField.disabled
                                ? t("placeholder.select")
                                : "",
                              watchDisable,
                              control,
                              OPTION_GROUP[itemField.field],
                              caculateHHDV,
                              "top",
                              itemField.allowCreate
                            )}
                          </td>
                        );
                      case "date":
                        return (
                          <td key={item}>
                            <FormGroup className="mb-2">
                              {generateDateField(
                                t(`form.${itemField.field}`),
                                "",
                                itemField.required,
                                errors,
                                itemField.field,
                                "DD/MM/YYYY",
                                itemField.disabled,
                                control,
                                optionDateLocale
                              )}
                            </FormGroup>
                          </td>
                        );
                      default:
                        break;
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  const onChangeHandle = (data, field) => {
    switch (field) {
      case "send_mail":
        setInputCBSendMailChange(data);
        break;
      case "ttchung_dvtte":
        autoSumGroupAll();
        break;
      case "nmua_mst":
        setInputMSTChange(data);
        if (data.length === 10 || data.length === 14) {
          setDisableBtnInfoByTax(true);
        }
        break;
      case "nmua_stknhang":
        if (data?.bank_name) {
          setValue("nmua_tnhang", data.bank_name, { shouldValidate: true });
        }
        break;
      case "nmua_mkhang":
        if (data) {
          for (const item in mapData) {
            const finalData = data[item];
            if (
              item === FIELD_CUSTOMER.STKNHANG ||
              item === FIELD_CUSTOMER.MA
            ) {
              setValue(
                mapData[item],
                {
                  value: finalData,
                  label: finalData,
                } || null,
                {
                  shouldValidate: true,
                }
              );
            } else {
              setValue(mapData[item], finalData || "", {
                shouldValidate: true,
              });
            }
          }
        }
        // if (data?.bank_name) {
        //   setValue("nmua_tnhang", data.bank_name, { shouldValidate: true });
        // }
        break;
      default:
        break;
    }
  };

  const setEnterpriseInfo = (info, listMapValue) => {
    for (const key in listMapValue) {
      const defaultValue = info[listMapValue[key]];
      if (defaultValue) {
        setValue(key, defaultValue, { shouldValidate: true });
      } else {
        setValue(key, "", { shouldValidate: true });
      }
    }
  };

  // Set info người mua theo MST
  const setInfoBuyerByTaxCode = () => {
    if (enterpriseByTaxCode?.enterpriseInfo) {
      const defaultEnterpriseInfo = {
        [ISSUE_INVOICE_BUYER_FIELD.NMUA_TEN.field]: "companyNameVn",
        [ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field]: "registeredAddressVn",
        [ISSUE_INVOICE_BUYER_FIELD.NMUA_SDTHOAI.field]: "phone",
        // [ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field]: "email",
      };
      setEnterpriseInfo(
        enterpriseByTaxCode.enterpriseInfo,
        defaultEnterpriseInfo
      );
    }
    if (enterpriseByTaxCode?.entRepResentative) {
      //   const defaultEnterpriseInfo = {
      //     [ISSUE_INVOICE_BUYER_FIELD.NMUA_HVTNMHANG.field]: "representativeName",
      //   };
      //   setEnterpriseInfo(
      //     enterpriseByTaxCode.entRepResentative,
      //     defaultEnterpriseInfo
      //   );
    }
  };

  // Button load thông tin theo MST
  const buttonLoadBuyerInfoByTax = () => {
    const disableBtn =
      disableBtnInfoByTax ||
      (getValues("nmua_mst").length !== 10 &&
        getValues("nmua_mst").length !== 14) ||
      loadDingEnterpriseByTaxCode ||
      !enterpriseByTaxCode ||
      !enterpriseByTaxCode.enterpriseInfo;
    return (
      !disableForm && (
        <React.Fragment>
          {/* <button
            type="button"
            disabled={disableBtn}
            className={`btn btn-${disableBtn ? "warning" : "success"}`}
            onClick={() => {
              setInfoBuyerByTaxCode();
            }}
          > */}
          <button
            title={disableBtn ? "Chưa có thông tin" : "Load thông tin theo MST"}
            style={{
              width: "41px",
              height: "34px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "-9px",
            }}
            type="button"
            className={`btn btn-${disableBtn ? "warning" : "success"}`}
            onClick={() => {
              setInfoBuyerByTaxCode();
            }}
          >
            <i
              className={` ${
                loadDingEnterpriseByTaxCode
                  ? "bx bx-loader bx-spin"
                  : "fa fa-exclamation-circle"
              } font-size-16 align-middle`}
            ></i>
          </button>
          <div className="d-flex" style={{ width: "154px" }}>
            {/* </button> */}
            {isShowBtnAddCustomer && (
              <React.Fragment>
                <input
                  title="Lưu thông tin khách hàng để sử dụng lại"
                  type="checkbox"
                  id="checkbox_isSaveInfoCustomer"
                  className="custom-control-input checkbox-isSaveInfoCustomer"
                  style={{
                    minWidth: "30px",
                    height: "17px",
                    marginTop: "0px",
                  }}
                  {...register("isSaveInfoCustomer")}
                />
                <label
                  className="text-warning"
                  style={{
                    marginLeft: "2px",
                    marginTop: "-6px",
                  }}
                  htmlFor="checkbox_isSaveInfoCustomer"
                >
                  Lưu thông tin khách hàng
                </label>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      )
    );
  };

  // Button tìm khách hàng
  const buttonSeachCustomer = () => {
    return (
      !disableForm && (
        // <button
        //   type="button"
        //   style={{ width: "108px" }}
        //   className={`btn btn-primary`}
        //   onClick={() => {
        //     toggleSearchModal();
        //   }}
        // >
        <i
          title="Tìm kiếm"
          style={{ cursor: "pointer" }}
          onClick={() => {
            toggleSearchModal();
          }}
          className={`text-primary fas fa-search-plus font-size-16 align-middle me-2`}
        ></i>
        //   Tìm kiếm
        // </button>
      )
    );
  };

  // Button thêm tài khoản
  const buttonAddAccount = () => {
    return (
      !disableForm && (
        <button
          type="button"
          style={{
            height: "30px",
            width: "32px",
            background: "white",
            marginLeft: "7px",
          }}
          className={`btn btn-success d-flex align-items-center justify-content-center`}
          onClick={() => {
            toggleAddAccountBankModal();
          }}
        >
          <i
            title="Thêm tài khoản ngân hàng"
            style={{ cursor: "pointer" }}
            className={`text-success bx bx-plus-medical font-size-16 align-middle`}
          ></i>
        </button>
      )
    );
  };

  // Button thêm sản phẩm
  const buttonAddProduct = () => {
    return (
      <button
        type="button"
        style={{
          height: "30px",
          width: "32px",
          marginTop: "7px",
          background: "white",
          marginLeft: "2px",
          marginBottom: "8px",
          marginRight: "3px",
        }}
        className={`btn-add-product btn btn-success d-flex align-items-center justify-content-center`}
        title="Thêm sản phẩm mới"
        onClick={() => {
          toggleAddProductModal();
        }}
      >
        <i
          style={{ cursor: "pointer" }}
          className={`text-success bx bx-plus-medical font-size-16 align-middle`}
        ></i>
      </button>
    );
  };

  const getTitleModal = () => {
    let title = "";
    if (dataConfirmAction) {
      // Thay thế hóa đơn
      switch (dataConfirmAction.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          title = "Lập hóa đơn thay thế";
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          let typeAdjust = "";
          switch (dataConfirmAction.typeAdjust) {
            case TYPE_ADJUST_INVOICE.INCREASE:
              typeAdjust = "tăng";
              break;
            case TYPE_ADJUST_INVOICE.DECREASE:
              typeAdjust = "giảm";
              break;
            case TYPE_ADJUST_INVOICE.CHANGE_INFO:
              typeAdjust = "thay đổi thông tin";
              break;
            default:
              break;
          }
          title = "Lập hóa đơn điều chỉnh " + typeAdjust;
          break;
        default:
          break;
      }
    } else {
      switch (mode) {
        // Tạo mới
        case issueInvoiceModeList.CREATE_SALE_INVOICE_DETAIL:
          title = "Thêm mới hóa đơn bán hàng";
          break;
        case issueInvoiceModeList.CREATE_VAT_INVOICE_DETAIL:
          title = "Thêm mới hóa đơn GTGT";
          break;
        case issueInvoiceModeList.CREATE_INVOICE_TICKETS_DETAIL:
          title = "Thêm mới tem,vé (HĐ GTGT)";
          break;
        // Cập nhật
        case issueInvoiceModeList.EDIT_SALE_INVOICE_DETAIL:
          title = "Cập nhật hóa đơn bán hàng";
          break;
        case issueInvoiceModeList.EDIT_VAT_INVOICE_DETAIL:
          title = "Cập nhật hóa đơn GTGT";
          break;
        case issueInvoiceModeList.EDIT_INVOICE_TICKETS_DETAIL:
          title = "Cập nhật tem,vé (HĐ GTGT)";
          break;
        default:
          break;
      }
    }
    return title;
  };

  const getTextLinkOldInvoice = () => {
    let title = "";
    let id = null;
    if (dataConfirmAction) {
      const infoTT32 = dataConfirmAction.infoTT32;
      // Thay thế/ điều chỉnh hóa đơn tt32
      if (infoTT32) {
        const today = new Date(infoTT32.tthdlquan_nlhdclquan);
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();
        switch (infoTT32.modeTT32) {
          case MODE_INVOICE_ACTION.REPLACE:
            title = `Thay thế cho hóa đơn TT32 , Mẫu số: ${infoTT32.tthdlquan_khmshdclquan}, Ký hiệu: ${infoTT32.tthdlquan_khhdclquan}, Số: ${infoTT32.tthdlquan_shdclquan}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
            break;
          case MODE_INVOICE_ACTION.ADJUST:
            title = `Điều chỉnh cho hóa đơn TT32 , Mẫu số: ${infoTT32.tthdlquan_khmshdclquan}, Ký hiệu: ${infoTT32.tthdlquan_khhdclquan}, Số: ${infoTT32.tthdlquan_shdclquan}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
            break;
          default:
            break;
        }
      } else {
        // Thay thế hóa đơn
        const today = new Date(Number(dataConfirmAction.nlap) * 1000);
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();
        switch (dataConfirmAction.mode) {
          case MODE_INVOICE_ACTION.REPLACE:
            title = `Thay thế cho hóa đơn Mẫu số: ${dataConfirmAction.pattern}, Ký hiệu: ${dataConfirmAction.serial}, Số: ${dataConfirmAction.invoiceNo}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
            break;
          case MODE_INVOICE_ACTION.ADJUST:
            title = `Điều chỉnh cho hóa đơn Mẫu số: ${dataConfirmAction.pattern}, Ký hiệu: ${dataConfirmAction.serial}, Số: ${dataConfirmAction.invoiceNo}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
            break;
          default:
            break;
        }
        id = dataConfirmAction.id;
      }
    }
    //
    if (detailIssueInvoice?.root) {
      const today = new Date(detailIssueInvoice?.root.ttchung_nlap * 1000);
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      switch (detailIssueInvoice?.tthdlquan_tchdon) {
        case "1":
          title = `Thay thế cho hóa đơn Mẫu số: ${detailIssueInvoice?.root.ttchung_khmshdon}, Ký hiệu: ${detailIssueInvoice?.root.ttchung_khhdon}, Số: ${detailIssueInvoice?.root.ttchung_shdon}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        case "2":
          title = `Điều chỉnh cho hóa đơn Mẫu số: ${detailIssueInvoice?.root.ttchung_khmshdon}, Ký hiệu: ${detailIssueInvoice?.root.ttchung_khhdon}, Số: ${detailIssueInvoice?.root.ttchung_shdon}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        default:
          break;
      }
      id = detailIssueInvoice?.root.id;
    }
    // Thay thế cho hóa đơn thông tư 32
    if (detailIssueInvoice?.tthdlquan_lhdclquan === "3") {
      const today = new Date(detailIssueInvoice?.tthdlquan_nlhdclquan * 1000);
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      switch (detailIssueInvoice?.tthdlquan_tchdon) {
        case "1":
          title = `Thay thế cho hóa đơn TT32, Mẫu số: ${detailIssueInvoice?.tthdlquan_khmshdclquan}, Ký hiệu: ${detailIssueInvoice?.tthdlquan_khhdclquan}, Số: ${detailIssueInvoice?.tthdlquan_shdclquan}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        case "2":
          title = `Điều chỉnh cho hóa đơn TT32, Mẫu số: ${detailIssueInvoice?.tthdlquan_khmshdclquan}, Ký hiệu: ${detailIssueInvoice?.tthdlquan_khhdclquan}, Số: ${detailIssueInvoice?.tthdlquan_shdclquan}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        default:
          break;
      }
      id = null;
    }
    return (
      <div
        style={{ cursor: "pointer" }}
        onClick={() => {
          if (id) {
            showPdfById(id);
          }
        }}
        className="text-danger text-center font-size-20"
      >
        {title}
      </div>
    );
  };

  const getLabelButtonSubmit = () => {
    let title = "";
    if (dataConfirmAction) {
      // Thay thế /điều chỉnh hóa đơn
      switch (dataConfirmAction.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          title = "Lập hóa đơn";
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          title = "Lập hóa đơn";
          break;
        default:
          break;
      }
      // Cập nhật hóa đơn Thay thế /điều chỉnh ở trạng thái lưu tạm
      switch (dataConfirmAction.modeEdit) {
        case MODE_INVOICE_ACTION.REPLACE:
          title = "Cập nhật hóa đơn";
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          title = "Cập nhật hóa đơn";
          break;
        default:
          break;
      }
    } else {
      switch (mode) {
        // Tạo mới
        case issueInvoiceModeList.CREATE_SALE_INVOICE_DETAIL:
          title = "Lưu tạm";
          break;
        case issueInvoiceModeList.CREATE_VAT_INVOICE_DETAIL:
          title = "Lưu tạm";
          break;
        case issueInvoiceModeList.CREATE_INVOICE_TICKETS_DETAIL:
          title = "Lưu tạm";
          break;
        // Cập nhật
        case issueInvoiceModeList.EDIT_SALE_INVOICE_DETAIL:
          title = "Cập nhật";
          break;
        case issueInvoiceModeList.EDIT_VAT_INVOICE_DETAIL:
          title = "Cập nhật";
          break;
        case issueInvoiceModeList.EDIT_INVOICE_TICKETS_DETAIL:
          title = "Cập nhật";
          break;
        default:
          break;
      }
    }
    return title;
  };

  const numberWithCommas = (x, isShow) => {
    let dau = "";
    if (isShow) {
      dau = x > 0 ? "+" : "";
    }
    return dau + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const isErrorAdjust = () => {
    // return (
    //   (getValues("ttoan_tgtttbso") -
    //     Number(detailIssueInvoice?.ttoan_tgtttbso) >=
    //     0 &&
    //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE) ||
    //   (getValues("ttoan_tgtttbso") -
    //     Number(detailIssueInvoice?.ttoan_tgtttbso) <=
    //     0 &&
    //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.INCREASE)
    // );
    return false;
  };

  //Check show/hide with page view
  const checkShowWithPageView = item => {
    if (item.isShowWithPageView && item.isShowWithPageView.length > 0) {
      if (item.isShowWithPageView.findIndex(item => item === pageView) === -1) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  };

  const mapData = {
    [FIELD_CUSTOMER.TEN]: ISSUE_INVOICE_BUYER_FIELD.NMUA_TEN.field,
    [FIELD_CUSTOMER.MST]: ISSUE_INVOICE_BUYER_FIELD.NMUA_MST.field,
    [FIELD_CUSTOMER.DCHI]: ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field,
    [FIELD_CUSTOMER.MA]: ISSUE_INVOICE_BUYER_FIELD.NMUA_MKHANG.field,
    [FIELD_CUSTOMER.SDTHOAI]: ISSUE_INVOICE_BUYER_FIELD.NMUA_SDTHOAI.field,
    [FIELD_CUSTOMER.DCTDTU]: ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field,
    [FIELD_CUSTOMER.STKNHANG]: ISSUE_INVOICE_BUYER_FIELD.NMUA_STKNHANG.field,
    [FIELD_CUSTOMER.TNHANG]: ISSUE_INVOICE_BUYER_FIELD.NMUA_TNHANG.field,
  };
  const handleFiles = (files, uploadType = "") => {
    setListUploadFile([]);
    if (files.length > 0) {
      for (const item of files) {
        const bodyFormData = new FormData();
        bodyFormData.append("file", item);
        dispatch(uploadAttackFileInvoice(bodyFormData, uploadType));
      }
      if (modal && modal.current) {
        modal.current.scrollTop = modal.current.scrollHeight;
      }
    }
  };

  const generalFieldFirst = value => {
    let disableCheck = disableForm;
    // Nếu điều chỉnh thì cho nhập ngày lập
    if (isTypeAdjustChangeInfo || isTypeAdjustIncDesc) {
      switch (value.field) {
        case COMMON_FIELD.TTCHUNG_NLAP.field:
          disableCheck = false;
          break;
        default:
          break;
      }
    }
    return loopGenerateField(
      value,
      t(`form.${value.field}`),
      t("placeholder.enter", {
        title: t(`form.${value.field}`),
      }),
      errors,
      touchedFields,
      register,
      control,
      OPTION_GROUP,
      optionDateLocale,
      "",
      onChangeHandle,
      pageView,
      null,
      disableCheck,
      true,
      invoiceSymbolList,
      getKhhdDefault(),
      "",
      invoiceMaxDate?.data,
      null,
      currentTime?.data?.momentDate
    );
  };

  const generalField = value => {
    let placeholder = "";
    if (value.field === "nmua_mst") {
      placeholder = "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)";
    } else {
      placeholder = t("placeholder.enter", {
        title: t(`form.${value.field}`),
      });
    }
    return loopGenerateField(
      value,
      t(`form.${value.field}`),
      placeholder,
      errors,
      touchedFields,
      register,
      control,
      OPTION_GROUP,
      optionDateLocale,
      "",
      onChangeHandle,
      pageView,
      {
        [EXTRA_BUTTON.LOAD_TAX]: buttonLoadBuyerInfoByTax(),
        [EXTRA_BUTTON.SEARCH_CUSTOMER]: buttonSeachCustomer(),
        [EXTRA_BUTTON.ADD_ACCOUNT]: buttonAddAccount(),
      },
      disableForm,
      dataConfirmAction?.typeAdjust,
      [],
      "",
      mode,
      null,
      SECOND_BLOCK.map(item => item.field),
      currentTime?.data?.momentDate
    );
  };

  const exportProductExcel = async () => {
    const schema = [
      // Column #1
      {
        column: "STT",
        type: Number,
        value: product => product.stt,
      },
      // Column #2
      {
        column: "Mã sản phẩm",
        type: String,
        value: product => product.mhhdvu,
        width: 15,
      },
      // Column #3
      {
        column: "Hàng hóa",
        type: String,
        value: product => product.thhdvu,
        width: 15,
      },
      // Column #4
      {
        column: "Đơn vị tính",
        type: String,
        value: product => product.dvtinh,
        width: 15,
      },
      {
        column: "Số lượng",
        type: Number,
        value: product => product.sluong,
        width: 15,
      },
      {
        column: "Đơn giá",
        type: Number,
        value: product => product.dgia,
        width: 15,
      },
      {
        column: "Thành tiền",
        type: Number,
        value: product => product.thtien,
        width: 15,
      },
      {
        column: "Thuế suất",
        type: String,
        value: product => product.tsuat,
        width: 15,
      },
    ];
    let stt = 0;
    let listProduct = getValues(HHDV_FIELD.HHDV_OBJ.field);
    const objects = listProduct.map(item => {
      stt = stt + 1;
      let tsuat = item.tsuat.value + "%";
      if (item.tsuat.label === "KCT" || item.tsuat.label === "KKKNT") {
        tsuat = item.tsuat.label;
      }
      return {
        stt: stt,
        mhhdvu: String(item.mhhdvu),
        thhdvu: String(item.thhdvu),
        dvtinh: String(item.dvtinh),
        sluong: Number(item.sluong),
        dgia: Number(item.dgia),
        thtien: Number(item.thtien),
        tsuat: String(tsuat),
      };
    });
    // // When passing `data` for each cell.
    await writeXlsxFile(objects, {
      schema, // optional
      fileName: "DanhSachSanPham.xlsx",
      headerStyle: {
        backgroundColor: "#eeeeee",
        fontWeight: "bold",
        align: "center",
      },
    });
  };

  const importHandle = data => {
    toggleImportProductModal();
    setIsLoadTable(true);
    setValue(ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.field, data);
    setTimeout(() => {
      autoSumGroupAll();
    });
    changeToPage(0);
  };

  const defaultDataAdjustChangeInfo = () => {
    appendHHDV({
      [HHDV_FIELD.HHDV_OBJ.list.TCHAT.field]: OPTION_HHDV_TCHAT[3],
      [HHDV_FIELD.HHDV_OBJ.list.STT.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.DVTINH.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.SLUONG.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.DGIA.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.THTIEN.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: {
        value: "",
        label: "",
      },
      [HHDV_FIELD.HHDV_OBJ.list.TTKHAC.field]: "",
    });
    setValue(ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TGTCTHUE.field, 0, {
      shouldValidate: true,
    });
    setValue(ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TGTTHUE.field, 0, {
      shouldValidate: true,
    });
    setValue(ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TTCKTMAI.field, 0, {
      shouldValidate: true,
    });
    setValue(ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TGTTTBSO.field, 0, {
      shouldValidate: true,
    });
    setValue(ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TGTTTBCHU.field, "Không", {
      shouldValidate: true,
    });
  };

  return (
    <React.Fragment>
      <UploadProductExcelModal
        isOpen={modalImportProduct}
        listVat={listVat}
        OPTION_HHDV_TCHAT={OPTION_HHDV_TCHAT}
        toggle={toggleImportProductModal}
        importHandle={importHandle}
      ></UploadProductExcelModal>
      <CreateAccountBankModal
        dataDetail={null}
        isOpenModal={modalAccountBank}
        toggleModal={toggleAddAccountBankModal}
        mode={modeDetail.CREATE}
      />
      <DetailData
        dataDetail={null}
        isOpenModal={modalProduct}
        toggleModal={toggleAddProductModal}
        mode={modeDetail.CREATE}
      />
      <SearchCustomerModal
        mapData={mapData}
        setValueFunc={setValue}
        isOpen={modalSearch}
        toggle={toggleSearchModal}
      ></SearchCustomerModal>
      <Modal
        isOpen={isOpenModal}
        toggle={() => {
          toggleModal("", isPage);
        }}
        size="xl"
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        contentClassName="detail-data-format"
        style={{ maxWidth: "98%" }}
      >
        {/* {pageView}
        {mode}
        {JSON.stringify(dataConfirmAction)}
        {isTypeAdjustChangeInfo ? " isChangeInfo " : " isNotChangeInfo "}
        {disableForm ? " isdisableForm" : " isNotdisableForm"} */}
        {/* <ModalHeader toggle={toggleModal}>
        {/* {getTitleModal()}
          {pageView} */}
        {/* </ModalHeader> */}
        {loadingConfigField || loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="3"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div
                ref={modal}
                onKeyDown={e => {
                  if (
                    e.code === "F2" &&
                    isOpenModal &&
                    !disableForm &&
                    isEditableAdjustReplace
                  ) {
                    addNewRowHHDVHandle();
                  }
                }}
                tabIndex="0"
                style={{
                  maxHeight: "83vh",
                  overflow: "auto",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <div>{getTextLinkOldInvoice()}</div>

                {/* <div
                  className="custom-form-heading"
                  style={{ paddingTop: "0px" }}
                  >
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN CHUNG</strong>
                </div> */}

                <Row className="row-cols-1">
                  {Object.entries(
                    customViewField([
                      FIRST_BLOCK[0],
                      FIRST_BLOCK[1],
                      FIRST_BLOCK[2],
                    ])
                  ).map(([key, value]) => {
                    return generalFieldFirst(value);
                  })}
                </Row>
                <Row className="row-cols-1">
                  {Object.entries(
                    customViewField([
                      FIRST_BLOCK[3],
                      FIRST_BLOCK[4],
                      FIRST_BLOCK[5],
                    ])
                  ).map(([key, value]) => {
                    return generalFieldFirst(value);
                  })}
                </Row>
                <Row className="row-cols-1">
                  {Object.entries(customViewField([FIRST_BLOCK[6]])).map(
                    ([key, value]) => {
                      return generalFieldFirst(value);
                    }
                  )}
                </Row>
                {/* <div className="custom-form-heading mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN NGƯỜI BÁN</strong>
                </div> */}
                <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          SECOND_BLOCK[0],
                          SECOND_BLOCK[1],
                          SECOND_BLOCK[2],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1">
                      {Object.entries(
                        customViewField([SECOND_BLOCK[3], SECOND_BLOCK[4]])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1">
                      {Object.entries(
                        customViewField([
                          SECOND_BLOCK[5],
                          SECOND_BLOCK[6],
                          SECOND_BLOCK[7],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          SECOND_BLOCK[8],
                          SECOND_BLOCK[9],
                          SECOND_BLOCK[10],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          SECOND_BLOCK[11],
                          SECOND_BLOCK[12],
                          SECOND_BLOCK[13],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          SECOND_BLOCK[14],
                          SECOND_BLOCK[15],
                          SECOND_BLOCK[16],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                  </CardBody>
                </Card>

                {/* <div className="custom-form-heading  mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN NGƯỜI MUA</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-3">
                  {Object.entries(ISSUE_INVOICE_BUYER_FIELD).map(
                    ([key, value]) => {
                      let placeholder = "";
                      if (value.field === "nmua_mst") {
                        placeholder = "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)";
                      } else {
                        placeholder = t("placeholder.enter", {
                          title: t(`form.${value.field}`),
                        });
                      }
                      return loopGenerateField(
                        value,
                        t(`form.${value.field}`),
                        placeholder,
                        errors,
                        touchedFields,
                        register,
                        control,
                        OPTION_GROUP,
                        optionDateLocale,
                        "",
                        onChangeHandle,
                        "",
                        {
                          [EXTRA_BUTTON.LOAD_TAX]: buttonLoadBuyerInfoByTax(),
                          [EXTRA_BUTTON.SEARCH_CUSTOMER]: buttonSeachCustomer(),
                        },
                        disableForm,
                        dataConfirmAction?.typeAdjust !==
                          TYPE_ADJUST_INVOICE.CHANGE_INFO
                      );
                    }
                  )}
                </Row> */}
                {/* <div className="custom-form-heading  mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN DANH SÁCH HDDV</strong>
                </div> */}
                <div
                  className="mb-2 d-flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <div
                    style={{
                      fontStyle: "italic",
                      paddingTop: "20px",
                    }}
                  >
                    <div style={{ color: "#36a3f7" }}>
                      F2: thêm dòng, Enter: xuống dòng
                    </div>
                  </div>
                  <React.Fragment>
                    <div className="d-flex align-items-center">
                      <Button
                        className="me-2 d-flex gap-1"
                        color="info"
                        outline
                        onClick={() => {
                          exportProductExcel();
                        }}
                      >
                        <i
                          className="far fa-file-excel label-icon"
                          style={{ fontSize: "17px" }}
                        ></i>
                        Xuất file
                      </Button>
                      {!disableForm &&
                        !isTypeAdjustIncDesc &&
                        isEditableAdjustReplace && (
                          <Button
                            className="me-2 d-flex gap-1"
                            color="info"
                            outline
                            onClick={() => {
                              toggleImportProductModal();
                            }}
                          >
                            <i
                              className="far fa-file-excel label-icon"
                              style={{ fontSize: "17px" }}
                            ></i>
                            Nhập file
                          </Button>
                        )}
                    </div>
                  </React.Fragment>
                </div>
                {generateTable(
                  HHDV_FIELD.HHDV_OBJ.field,
                  HHDV_FIELD.HHDV_OBJ.list,
                  currentItemsHHDV,
                  removeNewRowHHDVHandle,
                  addNewRowHHDVHandle
                )}
                {/* <div className="custom-form-heading  mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN THANH TOÁN</strong>
                </div> */}
                {listPageViewHaveTSUAT.indexOf(pageView) !== -1 &&
                  isEnterprise && (
                    <React.Fragment>
                      <Label className="text-primary">
                        <strong>{t("form.ttoan_ltsuat_obj")}</strong>
                      </Label>
                      {generateTableSecond(
                        PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field,
                        PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list,
                        fieldsTTOAN_LTSUAT,
                        removeTTOAN_LTSUAT,
                        addNewLineTTOAN_LTSUAT,
                        true
                      )}
                    </React.Fragment>
                  )}

                {/* <Label className="text-primary">
              <strong>{t("form.ttoan_lphi_obj")}</strong>
            </Label>
            {generateTable(
              PAYMENT_FIELD.TTOAN_LPHI_OBJ.field,
              PAYMENT_FIELD.TTOAN_LPHI_OBJ.list,
              fieldsTTOAN_LPHI,
              removeTTOAN_LPHI,
              addNewLineTTOAN_LPHI
            )} */}
                <div
                  className="d-flex"
                  style={{ alignItems: "end", flexDirection: "column" }}
                >
                  {Object.entries(ISSUE_INVOICE_PAYMENT_FIELD).map(
                    ([key, item]) => {
                      let disable = disableForm;
                      if (
                        item.field === "ttoan_tgtttbchu" &&
                        isTypeAdjustIncDesc
                      ) {
                        disable = false;
                      }
                      return loopGenerateField(
                        item,
                        t(`form.${item.field}`),
                        t("placeholder.enter", {
                          title: t(`form.${item.field}`),
                        }),
                        errors,
                        touchedFields,
                        register,
                        control,
                        OPTION_GROUP,
                        optionDateLocale,
                        "custom-form",
                        null,
                        pageView,
                        null,
                        disable
                      );
                    }
                  )}

                  {(dataConfirmAction?.typeAdjust ===
                    TYPE_ADJUST_INVOICE.INCREASE ||
                    dataConfirmAction?.typeAdjust ===
                      TYPE_ADJUST_INVOICE.DECREASE) &&
                    dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST && (
                      <React.Fragment>
                        <Col>
                          <FormGroup className={`mb-2 custom-form `}>
                            <Label
                              className="text-warning"
                              // style={{ minWidth: "266px" }}
                            >
                              Tổng tiền thanh toán ban đầu của hóa đơn gốc:
                            </Label>
                            <div
                              className="label text-right"
                              style={{ width: "350px" }}
                            >
                              {detailIssueInvoice?.root?.ttoan_tgtttbso
                                ? numberWithCommas(
                                    Number(
                                      detailIssueInvoice?.root?.ttoan_tgtttbso
                                    )
                                  )
                                : numberWithCommas(
                                    Number(detailIssueInvoice?.ttoan_tgtttbso)
                                  )}
                            </div>
                          </FormGroup>
                        </Col>
                        {/* <Col>
                        <FormGroup className={`mb-2 custom-form`}>
                          <Label
                            className="text-info"
                            style={{ minWidth: "266px" }}
                          >
                            Tổng tiền thanh toán điều chỉnh:
                          </Label>
                          <div
                            className={
                              isErrorAdjust()
                                ? "text-danger label"
                                : "text-success label"
                            }
                          >
                            {numberWithCommas(
                              getValues("ttoan_tgtttbso") -
                                Number(detailIssueInvoice?.ttoan_tgtttbso),
                              true
                            )}
                          </div>
                        </FormGroup>
                      </Col> */}
                      </React.Fragment>
                    )}
                  {isShowLimitAdjust && (
                    <React.Fragment>
                      <Col>
                        <FormGroup className={`mb-2 custom-form `}>
                          <Label
                            className="text-info"
                            // style={{ minWidth: "266px" }}
                          >
                            Hạn mức điều chỉnh giảm:
                          </Label>
                          <div
                            className="label text-right"
                            style={{ width: "350px" }}
                          >
                            {detailIssueInvoice?.limit
                              ? numberWithCommas(
                                  Number(detailIssueInvoice?.limit)
                                )
                              : 0}
                          </div>
                        </FormGroup>
                      </Col>
                    </React.Fragment>
                  )}
                </div>
                {dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
                dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST ||
                listHaveUploadFile.length > 0 ? (
                  <React.Fragment>
                    <div className="custom-form-heading  mt-1">
                      <i className="fas fa-paperclip text-primary"></i>
                      <strong>BIÊN BẢN ĐÍNH KÈM</strong>
                    </div>
                    {(dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
                      dataConfirmAction?.mode ===
                        MODE_INVOICE_ACTION.ADJUST) && (
                      <Row>
                        <Col>
                          <UploadForm
                            multiple={true}
                            handleFiles={files => handleFiles(files)}
                            accept=".doc,.docx,.pdf"
                            removeFile={(a, index) => {
                              listUploadFile.splice(index, 1);
                              setListUploadFile(listUploadFile);
                            }}
                          ></UploadForm>
                        </Col>
                      </Row>
                    )}
                    {listHaveUploadFile.length > 0 &&
                      dataConfirmAction?.mode !== MODE_INVOICE_ACTION.REPLACE &&
                      dataConfirmAction?.mode !==
                        MODE_INVOICE_ACTION.ADJUST && (
                        <React.Fragment>
                          <div
                            className="dropzone-previews mt-3"
                            id="file-previews"
                          >
                            {listHaveUploadFile.map((f, i) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div className="p-2">
                                    <Row
                                      className="align-items-center"
                                      onClick={() => {
                                        dispatch(
                                          downloadXmlIssueInvoice(
                                            f.id,
                                            f.file_name,
                                            "blob",
                                            null,
                                            "." + f.file_type
                                          )
                                        );
                                      }}
                                    >
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold align-items-center font-size-18 d-flex gap-2"
                                        >
                                          <i
                                            className={`${getIconFile(
                                              f.file_type
                                            )} label-icon`}
                                          ></i>
                                          {f.file_name + "." + f.file_type}
                                        </Link>
                                        {/* <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p> */}
                                      </Col>
                                    </Row>
                                  </div>
                                </Card>
                              );
                            })}
                          </div>
                        </React.Fragment>
                      )}
                  </React.Fragment>
                ) : (
                  <React.Fragment></React.Fragment>
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              {mode !== issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL &&
                mode !== issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL &&
                mode !== issueInvoiceModeList.VIEW_INVOICE_TICKETS_DETAIL && (
                  <Button
                    color="primary"
                    className="btn-label"
                    type="button"
                    onClick={() => {
                      handleSubmit(onSubmit, beforeSubmit)();
                    }}
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      loadingUploadFile ||
                      isErrorAdjust()
                    }
                  >
                    <i className="bx bx-save label-icon"></i>
                    {getLabelButtonSubmit()}
                  </Button>
                )}
              {/* <Button color="success" className="btn-label" type="button">
                <i className="bx bx-save label-icon"></i>
                Ký
              </Button> */}
              {/* {btnShowFooter?.btnRelease?.isShow && (
                <Button color="success" className="btn-label" type="button">
                  <i className="bx bx-send font-size-18 label-icon"></i>
                  Phát hành & Kí số
                </Button>
              )} */}
              {/* Cần cấp duyệt */}
              {(detailIssueInvoice?.auth_status === AUTH_STATUS_NEW ||
                detailIssueInvoice?.auth_status === AUTH_STATUS_RR) &&
                detailIssueInvoice?.approve_status === APPROVE_STATUS_A &&
                finalBuInfo?.need_approve === 1 &&
                isRoleAccountant &&
                detailIssueInvoice?.auto_sign === 0 &&
                detailIssueInvoice?.source !== SOURCE_QUEUE.QUEUE_MSEAG && (
                  <Button
                    color="success"
                    className="btn-label"
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      loadingUploadFile ||
                      isErrorAdjust()
                    }
                    type="button"
                    onClick={() => {
                      handleSubmit(onRelease, beforeRelease)();
                    }}
                  >
                    <i className="bx bx-send font-size-18 label-icon"></i>
                    Phát hành & Kí số HSM
                  </Button>
                )}
              {/* Cần cấp duyệt */}
              {(detailIssueInvoice?.auth_status === AUTH_STATUS_NEW ||
                detailIssueInvoice?.auth_status === AUTH_STATUS_RR) &&
                finalBuInfo?.need_approve === 1 &&
                detailIssueInvoice?.auto_sign === 0 &&
                detailIssueInvoice?.source === SOURCE_QUEUE.QUEUE_MSEAG && (
                  <Button
                    color="success"
                    className="btn-label"
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      loadingUploadFile ||
                      isErrorAdjust()
                    }
                    type="button"
                    onClick={() => {
                      handleSubmit(onRelease, beforeRelease)();
                    }}
                  >
                    <i className="bx bx-send font-size-18 label-icon"></i>
                    Phát hành & Kí số HSM
                  </Button>
                )}
              {/* Không cần cấp duyệt */}
              {(detailIssueInvoice?.auth_status === AUTH_STATUS_NEW ||
                detailIssueInvoice?.auth_status === AUTH_STATUS_RR) &&
                finalBuInfo?.need_approve === 0 && (
                  <Button
                    color="success"
                    className="btn-label"
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      loadingUploadFile ||
                      isErrorAdjust()
                    }
                    type="button"
                    onClick={() => {
                      handleSubmit(onRelease, beforeRelease)();
                    }}
                  >
                    <i className="bx bx-send font-size-18 label-icon"></i>
                    Phát hành & Kí số HSM
                  </Button>
                )}
              {/*// Phat hanh hoa don doanh nghiêp và đã duyệt (Role cua hang) */}
              {isRoleStore &&
                (!dataConfirmAction || dataConfirmAction?.modeEdit) &&
                (detailIssueInvoice?.auth_status === AUTH_STATUS_NEW ||
                  detailIssueInvoice?.auth_status === AUTH_STATUS_RR) &&
                detailIssueInvoice?.auto_sign == 0 &&
                detailIssueInvoice?.source === SOURCE_QUEUE.DEFAULT &&
                detailIssueInvoice?.passersbyRoot && (
                  <Button
                    color="success"
                    className="btn-label"
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      loadingUploadFile ||
                      isErrorAdjust()
                    }
                    type="button"
                    onClick={() => {
                      handleSubmit(onRelease, beforeRelease)();
                    }}
                  >
                    <i className="bx bx-send font-size-18 label-icon"></i>
                    Phát hành & Kí số HSM
                  </Button>
                )}
              {btnShowFooter?.btnSubmit?.isShow && (
                <Button
                  color="success"
                  className="btn-label"
                  type="button"
                  disabled={
                    loadingCreate ||
                    loadingEdit ||
                    loadingUploadFile ||
                    isErrorAdjust()
                  }
                  onClick={() => {
                    handleSubmit(onSentApprove, beforeSendApprove)();
                  }}
                >
                  <i className="bx bx-send font-size-18 label-icon"></i>
                  Gửi duyệt hóa đơn
                </Button>
              )}
              {btnShowFooter?.btnSubmitEdit?.isShow &&
                (checkVisibleByConditionRowData(
                  btnShowFooter?.btnSubmitEdit?.listConditionRow[0],
                  detailIssueInvoice
                ) ||
                  checkVisibleByConditionRowData(
                    btnShowFooter?.btnSubmitEdit?.listConditionRow[1],
                    detailIssueInvoice
                  )) &&
                ((!dataConfirmAction &&
                  detailIssueInvoice?.approve_status === APPROVE_STATUS_M &&
                  detailIssueInvoice?.auth_status === AUTH_STATUS_NEW) ||
                  (dataConfirmAction && isRoleStore)) && (
                  <Button
                    color="success"
                    className="btn-label"
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      loadingUploadFile ||
                      isErrorAdjust()
                    }
                    type="button"
                    onClick={() => {
                      handleSubmit(onSentApprove, beforeSendApprove)();
                    }}
                  >
                    <i className="bx bx-send font-size-18 label-icon"></i>
                    Gửi duyệt hóa đơn
                  </Button>
                )}
              {/* <Button color="warning" className="btn-label" type="button">
                <i className="bx bxs-file-pdf label-icon"></i>
                Xem trước
              </Button> */}
              {(mode === issueInvoiceModeList.VIEW_SALE_INVOICE_DETAIL ||
                mode === issueInvoiceModeList.VIEW_VAT_INVOICE_DETAIL ||
                mode === issueInvoiceModeList.VIEW_INVOICE_TICKETS_DETAIL) && (
                <React.Fragment>
                  {/* <Button
                    type="button"
                    color="primary"
                    className="btn-label"
                    onClick={() => {
                      let resource_id = null;
                      let type = "";
                      if (detailIssueInvoice?.auth_status === AUTH_STATUS_NEW) {
                        type = "raw";
                      } else {
                        type = "signed";
                      }
                      resource_id = getResourceIdXML(
                        detailIssueInvoice.resource_list,
                        type
                      );
                      dispatch(
                        downloadXmlIssueInvoice(
                          resource_id,
                          detailIssueInvoice?.ttchung_thdon,
                          "blob",
                          typeInvoiceAnother
                        )
                      );
                    }}
                  >
                    <i className="bx bx-download label-icon"></i>
                    Download XML
                  </Button> */}
                  {/* <Button
                    type="button"
                    color="danger"
                    className="btn-label"
                    onClick={() => {
                      //   dispatch(
                      //     downloadXmlIssueInvoice(
                      //       detailRegistryInvoices?.resource_id,
                      //       detailRegistryInvoices?.ttchung_thdon
                      //     )
                      //   );
                    }}
                  >
                    <i className="bx bxs-file-pdf label-icon"></i>
                    Download PDF
                  </Button> */}
                </React.Fragment>
              )}
              <Button
                type="button"
                color="danger"
                className="me-2 btn-label"
                onClick={() => {
                  toggleModal("", isPage);
                }}
              >
                <i className="bx bx-x label-icon" />
                Đóng
              </Button>
            </ModalFooter>
          </React.Fragment>
        )}
      </Modal>
    </React.Fragment>
  );
});

DetailInvoice.propTypes = {
  btnShowFooter: PropTypes.any,
  isOpenModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  showPdfById: PropTypes.func,
  dataDetail: PropTypes.object,
  dataConfirmAction: PropTypes.any,
  mode: PropTypes.string,
  typeInvoiceAnother: PropTypes.string,
  khhdonDefault: PropTypes.string,
  pageView: PropTypes.string,
  invoiceSymbolList: PropTypes.array,
  setDataInvoiceTemp: PropTypes.any,
  isEnterprise: PropTypes.any,
  isPage: PropTypes.bool,
  setDataConfirmAction: PropTypes.func,
  setPageViewByRow: PropTypes.func,
  setMode: PropTypes.func,
  isRoleStore: PropTypes.any,
  isRoleAccountant: PropTypes.any,
  setTitleBodyDenyRelease: PropTypes.any,
  toggleDenyReleaseModal: PropTypes.any,
  setTitleBodyCheckRelease: PropTypes.any,
  toggleCheckReleaseModal: PropTypes.any,
};

DetailInvoice.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
  pageView: "",
  invoiceSymbolList: [],
  isPage: false,
  isRoleStore: false,
  isRoleAccountant: false,
};

export default DetailInvoice;
